// ==========================================
// Makers Shirt Kamakura - Kamakura Fit Concierge
// v6.0 - Enhanced UI Version (Unified Button Text + Notification Bubble)
// ==========================================
// Updates (v6.0):
// ✅ Floating badge removed (bottom-left notification disabled)
// ✅ Measurement status integrated into main button
// ✅ Size results integrated into button display
// ✅ Completion notification changed to bubble (auto-closes in 3 seconds)
// ✅ All v5.2 features inherited (high-precision sizing logic, armLength support, etc.)
// ==========================================

(function() {
  // Cloudflare Workers URL
  const GAS_ENDPOINT_URL = 'https://kfc-gemini.ozawa-r.workers.dev';
  
  window.KFCSizeMeasurement = {
    currentStep: 1,
    sizeTableHeaders: [],
	currentUnit: 'metric',  // ← この行を追加
    
open: function() {
  console.log('[KFC] open() function called');
  this.currentUnit = 'imperial';  // ← デフォルトはインペリアル
      
      // Execute first
      console.log('[KFC] Initializing dataLayer...');
      window.dataLayer = window.dataLayer || [];
      
      var eventData = {
        'event': 'kfc_button_clicked',
        'kfc_action': 'button_clicked',
        'product_name': this.getProductName(),
        'product_type': this.getProductType()
      };
      
      console.log('[KFC] Pushing button_clicked event:', eventData);
      window.dataLayer.push(eventData);
      console.log('[KFC] Event pushed. dataLayer length:', window.dataLayer.length);
      console.log('[KFC] Current dataLayer:', window.dataLayer);

      var modal = document.createElement('div');
      modal.id = 'kfc-modal-overlay';
      modal.style.cssText = 'display:flex; align-items:center; justify-content:center; position:fixed; z-index:9999; left:0; top:0; width:100%; height:100%; background:rgba(0,0,0,0.6); animation: kfc-fadeIn 0.3s ease;';
      
      var modalInner = document.createElement('div');
      // Adjusted for proper display on desktop, Adjusted modal margin
      modalInner.style.cssText = 'background:white; border-radius:20px; width:95%; max-width:620px; max-height:90vh; overflow-y:scroll; position:relative; box-shadow: 0 20px 60px rgba(0,0,0,0.3); animation: kfc-slideUp 0.4s ease;';
      
      var content = this.getHtmlTemplate();
      modalInner.innerHTML = content;
      
      modal.appendChild(modalInner);
      document.body.appendChild(modal);
      

this.currentStep = 1;
this.setupEventListeners(modalInner, modal);

// ✅ デフォルトでインペリアル表示に切り替え
setTimeout(function() {
  var heightMetricWrapper = modalInner.querySelector('#height-metric-wrapper');
  var heightImperialWrapper = modalInner.querySelector('#height-imperial-wrapper');
  var weightInput = modalInner.querySelector('#weight');
  var weightUnit = modalInner.querySelectorAll('.kfc-inline-unit')[1];
  
  if (heightMetricWrapper && heightImperialWrapper) {
    heightMetricWrapper.style.display = 'none';
    heightImperialWrapper.style.display = 'flex';
  }
  
  if (weightUnit) {
    weightUnit.textContent = 'lb';
  }
  
  // プレースホルダーと範囲を変更
  if (weightInput) {
    weightInput.min = '66';
    weightInput.max = '330';
    weightInput.placeholder = '132';
    weightInput.value = '';  // ← この行を追加：デフォルト値をクリア
  }
  
  var heightFeet = modalInner.querySelector('#height-feet');
  var heightInches = modalInner.querySelector('#height-inches');
  if (heightFeet) heightFeet.placeholder = '5';
  if (heightInches) heightInches.placeholder = '7';
}, 100);
      // Getting current product ID
      var currentProductId = this.getProductId();
      
      console.log('Current product ID:', currentProductId);
      
      // Using new cache management
      var validCache = this.loadCacheIfValid(currentProductId);
      
      if (validCache) {
        // Cache valid → Show results
        console.log('Valid cache found - showing saved result');
        this.displayResults(JSON.stringify(validCache), true);
      } else {
        // No cache or expired → Show form
        console.log('No valid cache - showing form');
        this.restoreFromLocalStorage();
      }
    },

    
    getProductId: function() {
      // Get product ID from page title (simple version)
      var title = document.title || '';
      // Use first part of title as key
      return title.split('|')[0].trim();
    },
    
    // Generate cache key
    getCacheKey: function(productId) {
      return 'kfc-cache-' + productId;
    },
    
    // Check cache expiration (24 hours)
    isCacheExpired: function(timestamp) {
      var now = Date.now();
      var expiryTime = 24 * 60 * 60 * 1000; // 24 hours
      return (now - timestamp) > expiryTime;
    },
    
    // Save cache (with expiration)
    saveCacheWithExpiry: function(productId, result) {
      if (!result || result.status === 'no_recommendation') {
        // Do not save no-recommendation results
        var cacheKey = this.getCacheKey(productId);
        localStorage.removeItem(cacheKey);
        return;
      }
      
      var cacheKey = this.getCacheKey(productId);
      var cacheData = {
        result: result,
        timestamp: Date.now(),
        expiresIn: 24 * 60 * 60 * 1000
      };
      try {
        localStorage.setItem(cacheKey, JSON.stringify(cacheData));
      } catch (e) {
        console.log('Failed to save cache:', e);
      }
    },
    
    // Load cache (with expiration check)
    loadCacheIfValid: function(productId) {
      var cacheKey = this.getCacheKey(productId);
      var cached = localStorage.getItem(cacheKey);
      
      if (!cached) {
        return null;
      }
      
      try {
        var cacheData = JSON.parse(cached);
        if (!cacheData.timestamp || this.isCacheExpired(cacheData.timestamp)) {
          // Expired → Delete
          localStorage.removeItem(cacheKey);
          return null;
        }
        return cacheData.result;
      } catch (e) {
        console.log('Failed to load cache:', e);
        localStorage.removeItem(cacheKey);
        return null;
      }
    },
    
    autoMeasureWithSavedData: function(savedData) {
      var self = this;
      
      // Hide form
      this.modalInner.querySelectorAll('[id^="step"]').forEach(function(step) {
        step.style.display = 'none';
      });
      
      // Show loading
      this.modalInner.querySelector('#loading').style.display = 'block';
      
      // Wait for DOM to be ready
      setTimeout(function() {
        var gender = savedData.gender;
        var h = parseFloat(savedData.height);
        var w = parseFloat(savedData.weight);
        var bust = savedData.bust ? parseFloat(savedData.bust) : null;
        var a = parseInt(savedData.age);
        var arm = savedData.armLength;
        var fit = savedData.fitPreference;
        var shape = savedData.bodyShape;
        var pri = savedData.priority;
        
        console.log('Auto-measuring with saved data:', { gender, h, w, a, arm, fit, shape, pri, bust });
        
        // Display input content on loading screen
        self.displayLoadingWithData(gender, h, w, a, arm, fit, shape, pri, bust);
      }, 300);
    },
    
    getHtmlTemplate: function() {
      return `
        <style>
          @keyframes kfc-fadeIn { from { opacity: 0; } to { opacity: 1; } }
          @keyframes kfc-slideUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
          
          /* Mac-style scrollbar */
          ::-webkit-scrollbar {
            width: 6px;
          }
          ::-webkit-scrollbar-track {
            background: transparent;
            margin: 50px 0;
          }
          ::-webkit-scrollbar-thumb {
            background: #B5A099;
            border-radius: 3px;
            min-height: 30px;
          }
          ::-webkit-scrollbar-thumb:hover {
            background: #9B8B7F;
          }
          
          .kfc-wrapper {
            background: white;
            border-radius: 20px;
            overflow: hidden;
            font-family: 'Noto Sans JP', 'Segoe UI', sans-serif;
          }
          
          /* Close button: adjusted styling */
          .kfc-close-btn {
           position: absolute;
           top: 0px;
           right: 0px;
             width: 36px;
             height: 36px;
             border: none;
             background: #6B5547; /* Brown background */
             border-radius: 50%;
             cursor: pointer;
             font-size: 20px;
             display: flex;
             align-items: center;
             justify-content: center;
             transition: all 0.3s;
             z-index: 10000; /* Front layer */
             color: white; /* White text */
             font-weight: 400;
             line-height: 1;
             box-shadow: 0 4px 12px rgba(0,0,0,0.2);
           }
          
           .kfc-close-btn:hover {
             background: #8B7355;
           }

           /* No margin on modal for proper desktop display */
           @media (max-width: 768px) {
             .kfc-close-btn {
                 position: fixed;
                 top: 5px;
                 right: 5px;
                 width: 25px;
                 height: 25px;
                 font-size: 18px;
                 z-index: 10000; /* Front layer */
             }
           }
          
          .kfc-header {
            background: linear-gradient(135deg, #8B7355 0%, #9B8B7F 100%);
            color: white;
            padding: 12px 15px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 12px;
          }
          
          .kfc-header-logo {
            width: 60px;
            height: 60px;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          
          .kfc-header-logo img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
          
          .kfc-header-content {
            text-align: center;
          }
          
          .kfc-header h1 {
            font-size: 18px;
            margin: 0;
            margin-bottom: 0px;
            font-weight: 700;
            letter-spacing: 0.5px;
            line-height: 1.4;
          }
          
          .kfc-header p {
            font-size: 11px;
            opacity: 0.95;
            font-weight: 300;
            letter-spacing: 0.5px;
            margin: 0;
            line-height: 1.4;
          }
          
          .kfc-progress-bar {
            height: 2px;
            background: #E8DDD3;
          }
          
          .kfc-progress-fill {
            height: 100%;
            background: linear-gradient(90deg, #8B7355, #9B8B7F);
            transition: width 0.3s ease;
          }
          
          .kfc-content {
            padding: 35px 30px;
            min-height: 500px;
            position: relative;
            background: #fefdfb;
          }
          
          .kfc-step {
            display: none;
            animation: kfc-slideIn 0.4s ease;
          }
          
          .kfc-step.active {
            display: block;
          }
          
          @keyframes kfc-slideIn {
            from { opacity: 0; transform: translateX(20px); }
            to { opacity: 1; transform: translateX(0); }
          }
          
          .kfc-step-title {
            font-size: 18px;
            font-weight: 600;
            color: #3d3331;
            margin-bottom: 28px;
            letter-spacing: 0.5px;
          }
          
          .kfc-form-group {
            margin-bottom: 22px;
          }
          
          .kfc-label {
            display: block;
            font-weight: 500;
            color: #6B5547;
            margin-bottom: 8px;
            font-size: 13px;
            letter-spacing: 0.3px;
          }
          
          .kfc-input {
            width: 100%;
            padding: 13px 14px;
            border: 1.5px solid #D9CCC0;
            border-radius: 8px;
            font-size: 15px;
            transition: all 0.3s;
            font-family: 'Noto Sans JP', sans-serif;
            color: #333;
            background: white;
            box-sizing: border-box;
          }
          
          .kfc-input::placeholder {
            color: #d0ccc4;
            opacity: 0.4;
          }
          
          .kfc-input:focus {
            outline: none;
            border-color: #8B7355;
            background: #f5f1ed;
            box-shadow: 0 0 0 3px rgba(139, 115, 85, 0.12);
          }
          
          /* Desktop horizontal layout */
          .kfc-inline-group {
            display: flex;
            align-items: center;
            gap: 16px;
            margin-bottom: 18px;
          }
          
          .kfc-inline-group .kfc-label {
            min-width: 45px;
            margin-bottom: 0;
            font-weight: 600;
          }
          
          .kfc-inline-input-wrapper {
            flex: 1;
            display: flex;
            align-items: center;
            gap: 8px;
          }
          
          .kfc-inline-input {
            flex: 1;
          }
          
          .kfc-inline-unit {
            font-size: 13px;
            color: #999;
            font-weight: 500;
            min-width: 30px;
            text-align: center;
          }
          
          /* バストフィールドの初期状態(Default非表示) */
          #bust-field {
            display: none;
          }
          
          /* Mobile dropdown */
          .kfc-input-select {
            display: none;
            width: 100%;
            padding: 12px 14px;
            font-size: 14px;
            border: 1.5px solid #D4CCBE;
            border-radius: 8px;
            font-family: 'Noto Sans JP', sans-serif;
            color: #333;
            background: white;
            background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%238B7355' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
            background-repeat: no-repeat;
            background-position: right 12px center;
            background-size: 16px;
            padding-right: 40px;
            appearance: none;
            -webkit-appearance: none;
            -moz-appearance: none;
          }
          
          .kfc-input-select:focus {
            outline: none;
            border-color: #8B7355;
            box-shadow: 0 0 0 3px rgba(139, 115, 85, 0.1);
          }
          
          /* Step 1 form layout adjustment (mobile: vertical) */
          @media (max-width: 768px) {
            /* Step 1: Stack labels and input fields vertically */
            .kfc-inline-group {
          gap: 8px;
          align-items: center;
          margin-bottom: 22px;
            }
            .kfc-inline-group .kfc-label {
            min-width: auto;
          width: 20%;
          margin-bottom: 0;
            }
            .kfc-inline-input-wrapper {
              width: 100%;
              gap: 12px;
            }
            .kfc-inline-input {
              display: block !important;
            }
            .kfc-input-select {
              display: none !important;
            }
          }
          
          .kfc-radio-group {
            display: flex;
            flex-direction: column;
            gap: 10px;
          }
          
          /* Fix: Keep gender options always horizontal */
          .kfc-gender-group {
            display: flex;
            align-items: flex-start; /* Align label and radio group vertically */
            gap: 12px;
            margin-bottom: 22px;
          }
          
          .kfc-gender-group .kfc-label {
            min-width: 45px;
            margin-bottom: 0;
            font-weight: 600;
            padding-top: 15px; /* Match radio button height */
          }
          
          .kfc-gender-radio-group {
            display: flex;
            gap: 12px;
            flex: 1;
            flex-wrap: wrap; /* Wrap if necessary on mobile */
          }
          
          .kfc-gender-radio-group .kfc-radio-option {
    flex: 1;
    padding: 10px 5px;
    margin-bottom: 0;
    width: 50%;
          }
          
          .kfc-radio-option {
            display: flex;
            align-items: flex-start;
            padding: 14px 16px;
            border: 1.5px solid #D9CCC0;
            border-radius: 10px;
            cursor: pointer;
            transition: all 0.3s;
            background: white;
          }
          
          .kfc-radio-option:hover {
            background: #f5f1ed;
            border-color: #9B8B7F;
          }
          
          .kfc-radio-option input[type="radio"] {
    margin: 3px 5px;
    cursor: pointer;
    width: 18px;
    height: 18px;
    accent-color: #8B7355;
    flex-shrink: 0;
          }
          
          .kfc-radio-option.selected {
            border-color: #8B7355;
            background: linear-gradient(135deg, rgba(139, 115, 85, 0.06), rgba(181, 160, 153, 0.06));
          }
          
          .kfc-radio-label {
            flex: 1;
            padding-top: 1px;
          }
          
          .kfc-radio-label-main {
            font-weight: 600;
            color: #333;
            font-size: 14px;
          }
          
          .kfc-radio-label-sub {
            font-size: 11px;
            color: #999;
            margin-top: 2px;
          }
          
          .kfc-button-group {
            display: flex;
            gap: 12px;
            margin-top: 35px;
          }
          
          .kfc-btn {
            flex: 1;
            padding: 14px;
            border: none;
            border-radius: 10px;
            font-size: 15px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.3s;
            letter-spacing: 0.5px;
            font-family: 'Noto Sans JP', sans-serif;
            box-sizing: border-box;
          }
          
          .kfc-btn-next {
            background: linear-gradient(135deg, #8B7355 0%, #9B8B7F 100%);
            color: white;
          }
          
          .kfc-btn-next:hover:not(:disabled) {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(139, 115, 85, 0.3);
          }
          
          .kfc-btn-next:disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }
          
          .kfc-btn-back {
            background: #E8DDD3;
            color: #6B5547;
          }
          
          .kfc-btn-back:hover {
            background: #DCD1C7;
          }
          
          .kfc-btn-submit {
            background: linear-gradient(135deg, #8B9D6F 0%, #9AAE7E 100%);
            color: white;
            width: 100%;
          }
          
          .kfc-btn-submit:hover:not(:disabled) {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(139, 157, 111, 0.3);
          }
          
          .kfc-loading {
            display: none;
            text-align: center;
            padding: 50px 30px;
          }
          
          .kfc-spinner {
            border: 4px solid #E8DDD3;
            border-top: 4px solid #8B7355;
            border-radius: 50%;
            width: 36px;
            height: 36px;
            animation: kfc-spin 1s linear infinite;
            margin: 0 auto 15px;
          }
          
          @keyframes kfc-spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          
          .kfc-loading p {
            color: #8B7355;
            font-weight: 600;
            font-size: 13px;
          }
          
          /* Hide "Measure again" button on loading screen */
          .kfc-loading #loadingInfo + div {
              display: none !important;
          }
          
          .kfc-error {
            background: #FEF4F1;
            color: #C85A54;
            padding: 12px 14px;
            border-radius: 8px;
            margin-bottom: 18px;
            display: none;
            font-size: 12px;
            border-left: 4px solid #C85A54;
          }
          
          /* Range input (meter) style - unified brown tones */
          input[type="range"] {
            -webkit-appearance: none;
            appearance: none;
            background: transparent;
            cursor: pointer;
          }
          
          input[type="range"]::-webkit-slider-thumb {
            -webkit-appearance: none;
            appearance: none;
            width: 28px;
            height: 28px;
            border-radius: 50%;
            /* Brown tones */
            background: linear-gradient(135deg, #8B7355 0%, #9B8B7F 100%); 
            cursor: pointer;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
            margin-top: -8px;
          }
          
          input[type="range"]::-moz-range-thumb {
            width: 28px;
            height: 28px;
            border-radius: 50%;
            /* Brown tones */
            background: linear-gradient(135deg, #8B7355 0%, #9B8B7F 100%);
            cursor: pointer;
            border: none;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
            margin-top: -8px;
          }
          
          input[type="range"]::-webkit-slider-runnable-track {
            /* Brown tones */
            background: linear-gradient(to right, #8B7355 0%, #8B7355 var(--value), #E8DDD3 var(--value), #E8DDD3 100%); 
            height: 12px;
            border-radius: 6px;
          }
          
          input[type="range"]::-moz-range-track {
            /* Brown tones */
            background: linear-gradient(to right, #8B7355 0%, #8B7355 var(--value), #E8DDD3 var(--value), #E8DDD3 100%);
            height: 12px;
            border-radius: 6px;
            border: none;
          }
          
          .kfc-results {
            display: none;
          }
          
          .kfc-result-title {
            font-size: 20px;
            font-weight: 600;
            color: #3d3331;
            margin-bottom: 20px;
          }
          
          .kfc-no-recommendation {
            text-align: center;
            padding: 40px 20px;
          }
          
          .kfc-no-recommendation-emoji {
            font-size: 48px;
            margin-bottom: 16px;
          }
          
          .kfc-no-recommendation-title {
            font-size: 18px;
            font-weight: 600;
            color: #3d3331;
            margin-bottom: 12px;
          }
          
          .kfc-no-recommendation-text {
            font-size: 13px;
            color: #666;
            line-height: 1.6;
          }
          
          .kfc-result-card {
            background: linear-gradient(135deg, white 0%, #fefdfb 100%);
            border-left: 6px solid #8B7355;
            padding: 22px 24px;
            margin-bottom: 18px;
            border-radius: 12px;
            animation: kfc-slideIn 0.5s ease;
            border: 1px solid #E8DDD3;
          }
          
          .kfc-result-card.secondary {
            border-left-color: #9B8B7F;
            animation-delay: 0.1s;
          }
          

          
          .kfc-result-size {
            font-size: 32px;
            font-weight: 700;
            color: #8B7355;
            letter-spacing: 1px;
          }


          
          .kfc-meter-bar {
            height: 20px;
            background: #E8DDD3;
            border-radius: 10px;
            overflow: hidden;
          }
          
          .kfc-meter-fill {
            height: 100%;
            background: linear-gradient(90deg, #8B7355, #9B8B7F);
            border-radius: 6px;
            width: 0;
            animation: kfc-meterFill 1.2s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
          }


.kfc-meter-label {
  font-size: 12px;
  color: #6B5547;
  font-weight: 600;
  margin-bottom: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
          
          @keyframes kfc-meterFill {
            from { width: 0; }
            to { width: var(--meter-width); }
          }


          .kfc-meter-label {
  font-size: 12px;
  color: #6B5547;
  font-weight: 600;
  margin-bottom: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

          .kfc-scores {
            display: grid;
            grid-auto-flow: column;
            grid-auto-columns: 1fr;
            gap: 8px;
            margin-bottom: 16px;
            padding: 4px 0;
          }
          
          .kfc-score-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 3px;
            padding: 8px 6px;
            background: #fefdfb;
            border-radius: 6px;
            border: 1px solid #E8DDD3;
          }
          
          .kfc-score-label {
            font-size: 8px;
            color: #999;
            font-weight: 600;
            text-transform: uppercase;
            white-space: nowrap;
            letter-spacing: 0.4px;
          }
          
          .kfc-score-value {
            font-size: 16px;
            font-weight: 700;
            color: #8B7355;
            line-height: 1;
          }
          
          .kfc-score-max {
            font-size: 8px;
            color: #D9CCC0;
            font-weight: 600;
          }
          
          .kfc-reasons {
            background: #fefdfb;
            padding: 12px 13px;
            border-radius: 6px;
            border: 1px solid #E8DDD3;
          }
          
          .kfc-reason-title {
            font-size: 8px;
            color: #999;
            font-weight: 700;
            margin-bottom: 5px;
            text-transform: uppercase;
            letter-spacing: 0.6px;
          }
          
          .kfc-reason-text {
            font-size: 11px;
            line-height: 1.4;
            color: #666;
          }
          
          .kfc-back-link {
            display: flex;
            align-items: center;
            gap: 6px;
            color: #8B7355;
            cursor: pointer;
            margin-top: 20px;
            font-weight: 600;
            font-size: 13px;
          }
          
          .kfc-back-link:hover {
            text-decoration: underline;
          }
          
          .kfc-step-indicator {
            text-align: center;
            color: #D9CCC0;
            font-size: 12px;
            margin-top: 28px;
            font-weight: 500;
          }
          
          /* --- Responsive design integrated from v6.1 --- */
          @media (max-width: 768px) {
            

            

            
            /* メーター内のラベルとテキストの配置を修正(テキストをメーターの上に配置) */
            .kfc-meter-container > div {
              display: flex;
              align-items: center;
              width: 100%;
            }

 

            
            .kfc-meter-bar {
              order: 3; /* Meter bar at the bottom */
              width: 100%;
              min-width: 100px;
              margin-top: 5px; /* Spacing between meter and text */
            }

            /* スコア部分の横スクロール(v61のデザイン要素) */
            .kfc-scores {
              display: flex;
              flex-wrap: nowrap; /* Prevent wrapping */
              overflow-x: auto; /* Enable horizontal scrolling */
              gap: 8px;
              -webkit-overflow-scrolling: touch;
              max-width: 100%; /* Adjust width to parent element */
              padding-bottom: 8px; /* Space for scroll bar */
              box-sizing: border-box;
            }
            
            .kfc-score-item {
              flex-shrink: 0; /* Prevent shrinking */
              min-width: 65px;
            }
          }
          /* --- Integrated CSS End --- */
        </style>
        
        <div class="kfc-wrapper">
          <button class="kfc-close-btn" onclick="document.getElementById('kfc-modal-overlay').remove();">×</button>
          
          <div class="kfc-header">
            <div class="kfc-header-logo">
              <img src="https://kamakurashirts.com/cdn/shop/t/89/assets/kfc_logo_w.png" alt="KFC Logo" style="max-height: 40px; width: auto;">
            </div>
            <div class="kfc-header-content">
              <h1>Kamakura Fit Concierge</h1>
              <p>AI recommends your perfect size</p>
            </div>
          </div>
          
          <div class="kfc-progress-bar">
            <div class="kfc-progress-fill" id="progressFill"></div>
          </div>
          
          <div class="kfc-content">
            <div id="errorMessage" class="kfc-error"></div>
            
<div class="kfc-step active" id="step1">
  <div class="kfc-step-title">STEP 1. Tell us your Gender, Height, Weight, and Age.</div>
  
<!-- ★★★ 新規: 単位切り替えボタン ★★★ -->
<div style="display: flex; justify-content: flex-end; margin-bottom: 20px; gap: 8px;">
  <button class="kfc-unit-toggle" data-unit="imperial" style="padding: 8px 14px; background: #8B7355; color: white; border: none; border-radius: 6px; font-size: 11px; font-weight: 600; cursor: pointer; font-family: 'Noto Sans JP', sans-serif; transition: all 0.3s;">ft'in / lb</button>
  <button class="kfc-unit-toggle" data-unit="metric" style="padding: 8px 14px; background: #E8DDD3; color: #6B5547; border: none; border-radius: 6px; font-size: 11px; font-weight: 600; cursor: pointer; font-family: 'Noto Sans JP', sans-serif; transition: all 0.3s;">cm / kg</button>
</div>
  
  <div class="kfc-gender-group">
                <label class="kfc-label">Gender</label>
                <div class="kfc-gender-radio-group">
                  <label class="kfc-radio-option" onchange="window.KFCSizeMeasurement.selectRadio(this)">
                    <input type="radio" name="gender" value="Male">
                    <div class="kfc-radio-label"><div class="kfc-radio-label-main">Male</div></div>
                  </label>
                  <label class="kfc-radio-option" onchange="window.KFCSizeMeasurement.selectRadio(this)">
                    <input type="radio" name="gender" value="Female">
                    <div class="kfc-radio-label"><div class="kfc-radio-label-main">Female</div></div>
                  </label>
                </div>
              </div>
              
<div class="kfc-form-group kfc-inline-group" id="height-group">
  <label class="kfc-label">Height</label>
  <div class="kfc-inline-input-wrapper">
    <!-- メトリック用 -->
    <div id="height-metric-wrapper" style="display: flex; align-items: center; gap: 8px; flex: 1;">
      <input type="number" id="height" min="140" max="210" step="1" placeholder="170" class="kfc-input kfc-inline-input">
      <select id="height-select" class="kfc-input-select"></select>
      <span class="kfc-inline-unit">cm</span>
    </div>
    
    <!-- インペリアル用（フィート/インチ） -->
<div id="height-imperial-wrapper" style="display: none; flex: 1; gap: 8px; align-items: center;">
  <input type="number" id="height-feet" min="4" max="6" step="1" placeholder="5" class="kfc-input kfc-inline-input" style="flex: 0.6; max-width: 100px;">
  <div style="text-align: center; font-size: 13px; color: #999; font-weight: 600; min-width: 25px;">ft</div>
  <input type="number" id="height-inches" min="0" max="11" step="1" placeholder="7" class="kfc-input kfc-inline-input" style="flex: 0.6; max-width: 100px;">
  <div style="text-align: center; font-size: 13px; color: #999; font-weight: 600; min-width: 25px;">in</div>
</div>
              </div>  <!-- ← kfc-inline-input-wrapper の閉じタグ -->
            </div>  <!-- ← kfc-form-group の閉じタグ -->
              
              <div class="kfc-form-group kfc-inline-group">
                <label class="kfc-label">Weight</label>
                <div class="kfc-inline-input-wrapper">
                  <input type="number" id="weight" min="30" max="150" step="1" placeholder="60" class="kfc-input kfc-inline-input">
                  <select id="weight-select" class="kfc-input-select"></select>
                  <span class="kfc-inline-unit">kg</span>
                </div>
              </div>
              
<div class="kfc-form-group kfc-inline-group" id="bust-field">
  <label class="kfc-label">BUST<br><span style="font-size: 9px; color: #E74C3C; margin-left: 0;">(OPTIONAL)</span></label>
  <div class="kfc-inline-input-wrapper">
    <input type="number" id="bust" min="70" max="120" step="1" placeholder="85" class="kfc-input kfc-inline-input">
    <select id="bust-select" class="kfc-input-select"></select>
    <span class="kfc-inline-unit">cm</span>
  </div>
</div>
              
              <div class="kfc-form-group kfc-inline-group">
                <label class="kfc-label">Age</label>
                <div class="kfc-inline-input-wrapper">
                  <input type="number" id="age" min="18" max="100" step="1" placeholder="35" class="kfc-input kfc-inline-input">
                  <select id="age-select" class="kfc-input-select"></select>
                  <span class="kfc-inline-unit"></span>
                </div>
              </div>
              
              <div class="kfc-button-group">
                <button class="kfc-btn kfc-btn-next" onclick="window.KFCSizeMeasurement.goToStep(2)">Next →</button>
              </div>
              <div class="kfc-step-indicator">1/4</div>

<div style="margin-top: 20px; padding-top: 10px; border-top: 1px solid #E8DDD3; font-size: 10px; color: #999; text-align: center;">This tool is in beta and only supports certain shirts.</div>
            </div>
            
            <div class="kfc-step" id="step2">
              <div class="kfc-step-title">STEP 2. What is your arm length?</div>
              <div class="kfc-form-group">
                <div class="kfc-radio-group">
                  <label class="kfc-radio-option" onchange="window.KFCSizeMeasurement.selectRadio(this)">
                    <input type="radio" name="armLength" value="Shorter">
                    <div class="kfc-radio-label"><div class="kfc-radio-label-main">Shorter</div></div>
                  </label>
                  <label class="kfc-radio-option" onchange="window.KFCSizeMeasurement.selectRadio(this)">
                    <input type="radio" name="armLength" value="Normal">
                    <div class="kfc-radio-label"><div class="kfc-radio-label-main">Normal</div></div>
                  </label>
                  <label class="kfc-radio-option" onchange="window.KFCSizeMeasurement.selectRadio(this)">
                    <input type="radio" name="armLength" value="Longer">
                    <div class="kfc-radio-label"><div class="kfc-radio-label-main">Longer</div></div>
                  </label>
                </div>
              </div>
              <div class="kfc-button-group">
                <button class="kfc-btn kfc-btn-back" onclick="window.KFCSizeMeasurement.goToStep(1)">← Back</button>
                <button class="kfc-btn kfc-btn-next" onclick="window.KFCSizeMeasurement.goToStep(3)">Next →</button>
              </div>
              <div class="kfc-step-indicator">2/4</div>
            </div>
            
            <div class="kfc-step" id="step3">
              <div class="kfc-step-title">STEP 3. Tell us about your body characteristics</div>
              <div class="kfc-form-group">
                <div style="margin-bottom: 32px;">
                  <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 18px;">
                    <div style="width: 4px; height: 20px; background: #8B7355; border-radius: 2px;"></div>
                    <h3 style="font-weight: 700; color: #333; font-size: 15px; letter-spacing: 0.5px; margin: 0;">Body Shape</h3>
                  </div>
                  <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 20px;">
                    <span style="font-size: 12px; color: #999; min-width: 50px;">Slender</span>
                    <input type="range" id="bodyType" name="bodyType" min="1" max="5" value="3" style="flex: 1; height: 12px; border-radius: 6px; background: #E8DDD3!important; outline: none; -webkit-appearance: slider-horizontal; cursor: pointer;">
                    <span style="font-size: 12px; color: #999; min-width: 50px; text-align: right;">Larger</span>
                  </div>
                  <div style="background: #F9F8F6; border: 1px solid #E8DDD3; border-radius: 8px; padding: 10px 14px; text-align: center; width:50%; margin:auto;">
                    <span id="bodyTypeLabel" style="font-size: 13px; font-weight: 600; color: #8B7355;">Normal</span>
                  </div>
                </div>
                
                <div>
                  <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 18px;">
                    <div style="width: 4px; height: 20px; background: #8B7355; border-radius: 2px;"></div>
                    <h3 style="font-weight: 700; color: #333; font-size: 15px; letter-spacing: 0.5px; margin: 0;">Muscle Mass</h3>
                  </div>
                  <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 20px;">
                    <span style="font-size: 12px; color: #999; min-width: 50px;">Low</span>
                    <input type="range" id="muscleMass" name="muscleMass" min="1" max="5" value="3" style="flex: 1; height: 12px; border-radius: 6px; background: #E8DDD3!important; outline: none; -webkit-appearance: slider-horizontal; cursor: pointer;">
                    <span style="font-size: 12px; color: #999; min-width: 50px; text-align: right;">High</span>
                  </div>
                  <div style="background: #F9F8F6; border: 1px solid #E8DDD3; border-radius: 8px; padding: 10px 14px; text-align: center; width:50%; margin:auto;">
                    <span id="muscleMassLabel" style="font-size: 13px; font-weight: 600; color: #8B7355;">Normal</span>
                  </div>
                </div>
              </div>
              
              <div class="kfc-button-group">
                <button class="kfc-btn kfc-btn-back" onclick="window.KFCSizeMeasurement.goToStep(2)">← Back</button>
                <button class="kfc-btn kfc-btn-next" onclick="window.KFCSizeMeasurement.goToStep(4)">Next →</button>
              </div>
              <div class="kfc-step-indicator">3/4</div>
            </div>
            
            <div class="kfc-step" id="step4">
              <div class="kfc-step-title">STEP 4. What is your priority for this shirt?</div>
              
              <div class="kfc-form-group">
                <div class="kfc-radio-group">
                  <label class="kfc-radio-option" onchange="window.KFCSizeMeasurement.selectRadio(this)">
                    <input type="radio" name="priority" value="Clean silhouette">
                    <div class="kfc-radio-label">
                      <div class="kfc-radio-label-main">Clean Silhouette</div>
                      <div class="kfc-radio-label-sub">A beautiful overall silhouette</div>
                    </div>
                  </label>
                  <label class="kfc-radio-option" onchange="window.KFCSizeMeasurement.selectRadio(this)">
                    <input type="radio" name="priority" value="Comfortable fit">
                    <div class="kfc-radio-label">
                      <div class="kfc-radio-label-main">Moderate Room</div>
                      <div class="kfc-radio-label-sub">Comfortable, relaxed fit</div>
                    </div>
                  </label>
                  <label class="kfc-radio-option" onchange="window.KFCSizeMeasurement.selectRadio(this)">
                    <input type="radio" name="priority" value="Easy movement">
                    <div class="kfc-radio-label">
                      <div class="kfc-radio-label-main">Easy Movement</div>
                      <div class="kfc-radio-label-sub">Room for active mobility</div>
                    </div>
                  </label>
                  <label class="kfc-radio-option" onchange="window.KFCSizeMeasurement.selectRadio(this)">
                    <input type="radio" name="priority" value="Neck/sleeve length">
                    <div class="kfc-radio-label">
                      <div class="kfc-radio-label-main">Neck/Sleeve Details</div>
                      <div class="kfc-radio-label-sub">Accurate neck and sleeve fit</div>
                    </div>
                  </label>
                </div>
              </div>
              
              <div id="otherPriorityInput" style="display: none; margin-top: 16px;">
                <input type="text" id="otherPriority" placeholder="Enter your priority" class="kfc-input" style="width: 100%; padding: 10px; border: 1px solid #E8DDD3; border-radius: 6px; font-size: 14px; font-family: 'Noto Sans JP', sans-serif;">
              </div>
              
              <div class="kfc-button-group">
                <button class="kfc-btn kfc-btn-back" onclick="window.KFCSizeMeasurement.goToStep(3)">← Back</button>
                <button class="kfc-btn kfc-btn-submit" onclick="window.KFCSizeMeasurement.submitForm()">Get Size Recommendation →</button>
              </div>
              <div class="kfc-step-indicator">4/4</div>
            </div>
            
            <div class="kfc-loading" id="loading">
              <div class="kfc-spinner"></div>
              <p>AI is analyzing your size...</p>
              <p style="font-size: 11px; color: #999; margin-top: 5px;">This may take 30 seconds to 1 minute.</p>
              
              <div style="margin: 20px 0; padding: 0 16px;">
                <div style="font-size: 10px; color: #999; margin-bottom: 8px; display: flex; justify-content: space-between;">
                  <span>Measurement progress</span>
                  <span id="progressPercent">0%</span>
                </div>
                <div style="width: 100%; height: 8px; background: #f0f0f0; border-radius: 4px; overflow: hidden;">
                  <div id="progressBar" style="height: 100%; background: linear-gradient(90deg, #6B5547, #8B7355); border-radius: 4px; width: 0%; transition: width 0.3s ease; box-shadow: 0 0 10px rgba(107, 85, 71, 0.3);"></div>
                </div>
              </div>
              
              <div id="loadingInfo" style="background:#fefdfb; border:1px solid #E8DDD3; border-radius:8px; padding:12px; margin-top:15px; max-height:200px; overflow-y:auto; text-align:left;"></div>
              
              </div>
            
            <div class="kfc-results" id="results">
              <div class="kfc-result-title" id="resultTitle"> Size Recommendation</div>
              <div id="resultContent"></div>


              <div id="resultLoadingInfo" style="background:#fefdfb; border:1px solid #E8DDD3; border-radius:8px; padding:12px; margin-top:25px; max-height:200px; overflow-y:auto; text-align:left;"></div>


              <div class="kfc-back-link" onclick="window.KFCSizeMeasurement.backToForm()">← Try Again with Different Inputs</div>
              <div style="margin-top: 20px; padding-top: 10px; border-top: 1px solid #E8DDD3; font-size: 10px; color: #999; text-align: center;">This tool is in beta and only supports certain shirts.</div>
            </div>
          </div>
        </div>
      `;
    },
    
setupEventListeners: function(modalInner, modal) {
  this.modalInner = modalInner;
  this.modal = modal;
  this.initializeSelects();
  this.initializeMeters();
  this.initializeUnitToggle(modalInner);  // ← この行を追加
},
	  
initializeMeters: function() {
      var self = this;
      
      // Body Shape Meter
      var bodyTypeSlider = this.modalInner.querySelector('#bodyType');
      if (bodyTypeSlider) {
        var bodyTypeLabels = ['', 'Slender', 'Slightly Slender', 'Normal', 'Slightly Larger', 'Larger'];
        bodyTypeSlider.addEventListener('input', function() {
          self.modalInner.querySelector('#bodyTypeLabel').textContent = bodyTypeLabels[this.value];
        });
        bodyTypeSlider.dispatchEvent(new Event('input'));
      }
      
      // Muscle Mass Meter
      var muscleMassSlider = this.modalInner.querySelector('#muscleMass');
      if (muscleMassSlider) {
        var muscleMassLabels = ['', 'Low', 'Low', 'Normal', 'Slightly High', 'High'];
        muscleMassSlider.addEventListener('input', function() {
          self.modalInner.querySelector('#muscleMassLabel').textContent = muscleMassLabels[this.value];
        });
        muscleMassSlider.dispatchEvent(new Event('input'));
      }
    },
    
initializeUnitToggle: function(modalInner) {
  var self = this;
  var unitToggleButtons = modalInner.querySelectorAll('.kfc-unit-toggle');
  
  unitToggleButtons.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var unit = this.dataset.unit;
      
      // 同じユニットならスキップ
      if (self.currentUnit === unit) {
        return;
      }
      
      // 単位を切り替え
      self.switchUnit(unit, modalInner);
      
      // ボタンのスタイルを更新
      unitToggleButtons.forEach(function(b) { 
        b.style.background = '#E8DDD3'; 
        b.style.color = '#6B5547'; 
      });
      this.style.background = '#8B7355';
      this.style.color = 'white';
    });
  });
  
// デフォルトをインペリアルに設定
this.currentUnit = 'imperial';
if (unitToggleButtons.length > 1) {
  // 1番目のボタン（ft'in/lb）をアクティブに
  unitToggleButtons[0].style.background = '#8B7355';
  unitToggleButtons[0].style.color = 'white';
  
  // 2番目のボタン（cm/kg）を非アクティブに
  unitToggleButtons[1].style.background = '#E8DDD3';
  unitToggleButtons[1].style.color = '#6B5547';
}
}, 
    
switchUnit: function(unit, modalInner) {
  // 既に同じユニットの場合はスキップ
  if (this.currentUnit === unit) {
    console.log('[KFC] Already in ' + unit + ' mode');
    return;
  }
  
  var heightMetricWrapper = modalInner.querySelector('#height-metric-wrapper');
  var heightImperialWrapper = modalInner.querySelector('#height-imperial-wrapper');
  var heightInput = modalInner.querySelector('#height');
  var heightFeet = modalInner.querySelector('#height-feet');
  var heightInches = modalInner.querySelector('#height-inches');
  var weightInput = modalInner.querySelector('#weight');
  var heightUnits = modalInner.querySelectorAll('.kfc-inline-unit');
  
  if (unit === 'imperial') {
    // メトリック → インペリアルに変換
    var heightCm = parseFloat(heightInput.value);
    var weightKg = parseFloat(weightInput.value);
    
    // 値がない場合はデフォルト値を使用
    if (isNaN(heightCm)) heightCm = 170;
    if (isNaN(weightKg)) weightKg = 60;
    
    // 変換計算
    var totalInches = heightCm / 2.54;
    var feet = Math.floor(totalInches / 12);
    var inches = Math.round((totalInches % 12) * 10) / 10;
    var weightLb = Math.round(weightKg * 2.20462 * 10) / 10;
    
    // Display を切り替え
    heightMetricWrapper.style.display = 'none';
    heightImperialWrapper.style.display = 'flex';
    
    // 値を設定
    heightFeet.value = feet;
    heightInches.value = inches;
    weightInput.value = weightLb;
    
    // ユニット表記を変更
    if (heightUnits[1]) heightUnits[1].textContent = 'lb';
    
    // 入力範囲を変更
    weightInput.min = '66';
    weightInput.max = '330';
    weightInput.placeholder = '132';
	
    // Bust フィールドの単位を「in」に変更
    var bustInput = modalInner.querySelector('#bust');
    var bustUnits = modalInner.querySelector('#bust-field .kfc-inline-unit');
    
    if (bustInput && bustInput.value) {
      var bustCm = parseFloat(bustInput.value);
      var bustIn = Math.round(bustCm / 2.54 * 10) / 10;
      bustInput.value = bustIn;
    }
    
    if (bustUnits) {
      bustUnits.textContent = 'in';
    }
    
    // BUST の入力範囲を変更
    bustInput.min = '27.5';  // 70 cm ÷ 2.54
    bustInput.max = '47.2';  // 120 cm ÷ 2.54
    bustInput.placeholder = '33.5';  // 85 cm ÷ 2.54
    
    console.log('[KFC] Switched to Imperial: ' + feet + "'" + inches + '", ' + weightLb + 'lb');
    
  } else {
    // インペリアル → メトリックに変換
    var feet = parseFloat(heightFeet.value);
    var inches = parseFloat(heightInches.value);
    var weightLb = parseFloat(weightInput.value);
    
    // 値がない場合はデフォルト値を使用
    if (isNaN(feet)) feet = 5;
    if (isNaN(inches)) inches = 7;
    if (isNaN(weightLb)) weightLb = 132;
    
    // 変換計算
    var totalInches = feet * 12 + inches;
    var heightCm = Math.round(totalInches * 2.54 * 10) / 10;
    var weightKg = Math.round(weightLb / 2.20462 * 10) / 10;
    
    // Display を切り替え
    heightMetricWrapper.style.display = 'flex';
    heightImperialWrapper.style.display = 'none';
    
    // 値を設定
    heightInput.value = heightCm;
    weightInput.value = weightKg;
    
    // ユニット表記を変更
    if (heightUnits[1]) heightUnits[1].textContent = 'kg';
    
    // 入力範囲を変更
    heightInput.min = '140';
    heightInput.max = '210';
    heightInput.placeholder = '170';
    weightInput.min = '30';
    weightInput.max = '150';
    weightInput.placeholder = '60';
	
   // ✅ BUST フィールドの単位と値を変更
    var bustInput = modalInner.querySelector('#bust');
    var bustUnits = modalInner.querySelector('#bust-field .kfc-inline-unit');
    
    if (bustInput && bustInput.value) {
      var bustIn = parseFloat(bustInput.value);
      var bustCm = Math.round(bustIn * 2.54 * 10) / 10;
      bustInput.value = bustCm;
    }
    
    if (bustUnits) {
      bustUnits.textContent = 'cm';
    }
    
    // BUST の入力範囲を変更
    bustInput.min = '70';
    bustInput.max = '120';
    bustInput.placeholder = '85';
    
    console.log('[KFC] Switched to Metric: ' + heightCm + 'cm, ' + weightKg + 'kg');
  }
  
  this.currentUnit = unit;
},
    
    initializeSelects: function() {
      var self = this;
      
      // (145-200cm)
      var heightSelect = this.modalInner.querySelector('#height-select');
      if (heightSelect) {
        var option = document.createElement('option');
        option.value = '';
        option.textContent = 'Select height';
        heightSelect.appendChild(option);
        
        for (var i = 145; i <= 200; i++) {
          var opt = document.createElement('option');
          opt.value = i;
          opt.textContent = i;
          heightSelect.appendChild(opt);
        }
        heightSelect.addEventListener('change', function() {
          if (this.value) {
            self.modalInner.querySelector('#height').value = this.value;
          }
        });
      }
      
      // (40-150kg)
      var weightSelect = this.modalInner.querySelector('#weight-select');
      if (weightSelect) {
        var option = document.createElement('option');
        option.value = '';
        option.textContent = 'Select weight';
        weightSelect.appendChild(option);
        
        for (var i = 40; i <= 150; i++) {
          var opt = document.createElement('option');
          opt.value = i;
          opt.textContent = i;
          weightSelect.appendChild(opt);
        }
        weightSelect.addEventListener('change', function() {
          if (this.value) {
            self.modalInner.querySelector('#weight').value = this.value;
          }
        });
      }
      
      // (18-100)
      var ageSelect = this.modalInner.querySelector('#age-select');
      if (ageSelect) {
        var option = document.createElement('option');
        option.value = '';
        option.textContent = 'Select age';
        ageSelect.appendChild(option);
        
        for (var i = 18; i <= 100; i++) {
          var opt = document.createElement('option');
          opt.value = i;
          opt.textContent = i;
          ageSelect.appendChild(opt);
        }
        ageSelect.addEventListener('change', function() {
          if (this.value) {
            self.modalInner.querySelector('#age').value = this.value;
          }
        });
      }
      
      // (Female use, 70-120cm)
      var bustSelect = this.modalInner.querySelector('#bust-select');
      if (bustSelect) {
        var option = document.createElement('option');
        option.value = '';
        option.textContent = 'Select bust';
        bustSelect.appendChild(option);
        
        for (var i = 70; i <= 120; i++) {
          var opt = document.createElement('option');
          opt.value = i;
          opt.textContent = i;
          bustSelect.appendChild(opt);
        }
        bustSelect.addEventListener('change', function() {
          if (this.value) {
            self.modalInner.querySelector('#bust').value = this.value;
          }
        });
      }
    },
	  
    // ★★★ 新規メソッド1: 単位切り替えボタンの初期化
    selectRadio: function(label) {
      var radio = label.querySelector('input[type="radio"]');
      if (!radio) return;
      
      this.modalInner.querySelectorAll('input[name="' + radio.name + '"]').forEach(function(r) {
        r.closest('.kfc-radio-option').classList.remove('selected');
      });
      
      radio.checked = true;
      label.classList.add('selected');
      
// Update default values when Gender is selected
if (radio.name === 'gender') {
  var heightInput = this.modalInner.querySelector('#height');
  var weightInput = this.modalInner.querySelector('#weight');
  var bustField = this.modalInner.querySelector('#bust-field');
  
  if (radio.value === 'Male') {
    // Height
    heightInput.min = '150';
    heightInput.max = '210';
    heightInput.placeholder = '170';
    heightInput.value = '170';  // ← Default value
    
    // Weight
    weightInput.min = '40';
    weightInput.max = '150';
    weightInput.placeholder = '60';
    weightInput.value = '60';  // ← Default value
    
    // Hide bust field
    if (bustField) {
      bustField.style.display = 'none';
    }
  } else if (radio.value === 'Female') {
    // Height
    heightInput.min = '145';
    heightInput.max = '210';
    heightInput.placeholder = '155';
    heightInput.value = '155';  // ← Default value
    
    // Weight
    weightInput.min = '40';
    weightInput.max = '150';
    weightInput.placeholder = '45';
    weightInput.value = '45';  // ← Default value
    
    // Show bust field
    if (bustField) {
      bustField.style.display = 'flex';
    }
  }
}
      
      // Removed "Other" option
      if (radio.name === 'priority') {
        var otherInput = this.modalInner.querySelector('#otherPriorityInput');
        if (otherInput) {
            otherInput.style.display = 'none';
        }
      }
    },
    
    updateProgress: function() {
      var progress = (this.currentStep / 4) * 100;
      this.modalInner.querySelector('#progressFill').style.width = progress + '%';
    },
    
goToStep: function(step) {
  // ✅ 最初にエラーメッセージをクリア
  this.modalInner.querySelector('#errorMessage').style.display = 'none';
  
  if (step > this.currentStep) {
    var isValid = false;
    
    if (this.currentStep === 1) {
      var gender = this.modalInner.querySelector('input[name="gender"]:checked');
      
// Check both mobile dropdown and text input
var heightInput = this.modalInner.querySelector('#height');
var weightInput = this.modalInner.querySelector('#weight');
var ageInput = this.modalInner.querySelector('#age');

// 単位に応じて身長を取得
var h;
if (this.currentUnit === 'imperial') {
  var feet = parseFloat(this.modalInner.querySelector('#height-feet').value);
  var inches = parseFloat(this.modalInner.querySelector('#height-inches').value);
if (isNaN(feet) || isNaN(inches) || feet < 4 || feet > 7 || inches < 0 || inches > 11.9) {
  this.showError('Please enter Height (feet and inches) correctly. Feet: 4-7, Inches: 0-11.9');
  return;
}
  var totalInches = feet * 12 + inches;
  h = Math.round(totalInches * 2.54 * 10) / 10;  // cm に変換
} else {
  h = parseFloat(heightInput.value);
}

var w;
if (this.currentUnit === 'imperial') {
  var weightLb = parseFloat(weightInput.value);
  w = Math.round(weightLb / 2.20462 * 10) / 10;  // kg に変換
} else {
  w = parseFloat(weightInput.value);
}

var a = parseInt(ageInput.value);

// ===== バリデーション範囲（メトリックに統一） =====
// h は既に cm に統一済み、w も kg に統一済み
if (gender && h && w && a && h >= 140 && h <= 210 && w >= 30 && w <= 160 && a >= 18 && a <= 100) {
  isValid = true;
} else {
  this.showError('Please enter Gender, Height, Weight, and Age correctly. Weight: 30-160kg');
  return;
}
    } else if (this.currentStep === 2) {
      if (this.modalInner.querySelector('input[name="armLength"]:checked')) {
        isValid = true;
      } else {
        this.showError('Please select your Arm Length.');
        return;
      }
    } else if (this.currentStep === 3) {
      // (Sliders always have a value)
      isValid = true;
    } else if (this.currentStep === 4) {
      var priority = this.modalInner.querySelector('input[name="priority"]:checked');
      
      if (priority) {
        // "Other" option removed, no additional check needed
        isValid = true;
      } else {
        this.showError('Please select your Priority.');
        return;
      }
    }
    
    if (!isValid) return;
  }
  
  // Hide current step
  var currentStepEl = this.modalInner.querySelector('#step' + this.currentStep);
  if (currentStepEl) {
    currentStepEl.classList.remove('active');
  }
  
  // Show new step
  this.currentStep = step;
  var nextStepEl = this.modalInner.querySelector('#step' + step);
  if (nextStepEl) {
    nextStepEl.classList.add('active');
    console.log('Moved to step:', step);
  }
  
  this.updateProgress();
},
submitForm: function() {
  var gender = this.modalInner.querySelector('input[name="gender"]:checked')?.value;
  
  // ✅ 修正：常に内部的には cm/kg で保管
  var h, w, bust;
  
  if (this.currentUnit === 'imperial') {
    // インペリアル → メトリックに変換
    var feet = parseFloat(this.modalInner.querySelector('#height-feet').value) || 5;
    var inches = parseFloat(this.modalInner.querySelector('#height-inches').value) || 7;
    var weightLb = parseFloat(this.modalInner.querySelector('#weight').value) || 132;
    var bustIn = gender === 'Female' ? parseFloat(this.modalInner.querySelector('#bust').value) : null;
    
    // Height: ft/in → cm
    var totalInches = feet * 12 + inches;
    h = Math.round(totalInches * 2.54 * 10) / 10;
    
    // Weight: lb → kg ★★★重要★★★
    w = Math.round(weightLb / 2.20462 * 10) / 10;
    
    // Bust: in → cm
    bust = bustIn ? Math.round(bustIn * 2.54 * 10) / 10 : null;
    
    console.log('[KFC] Converted to metric: ' + h + 'cm, ' + w + 'kg');
    
  } else {
    // メトリック（そのまま使用）
    h = parseFloat(this.modalInner.querySelector('#height').value);
    w = parseFloat(this.modalInner.querySelector('#weight').value);
    bust = gender === 'Female' ? parseFloat(this.modalInner.querySelector('#bust').value) : null;
  }
  
  var a = parseInt(this.modalInner.querySelector('#age').value);
  var arm = this.modalInner.querySelector('input[name="armLength"]:checked')?.value;
  var fit = null;

  // ========== ここで重複変換ブロックは削除されている！ ==========
  
  // Sending event to dataLayer
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event': 'kfc_form_submitted',
    'kfc_action': 'form_submitted',
    'kfc_gender': gender,
    'kfc_height': h,
    'kfc_weight': w,
    'kfc_age': a,
    'product_name': this.getProductName(),
    'product_type': this.getProductType()
  });

  // Get meter-style Body Shape and Muscle Mass
  var bodyTypeValue = parseInt(this.modalInner.querySelector('#bodyType').value);
  var muscleMassValue = parseInt(this.modalInner.querySelector('#muscleMass').value);
  
  // Convert meter values to string labels (English)
  var bodyTypeLabels = ['', 'Slender', 'Slightly Slender', 'Normal', 'Slightly Larger', 'Larger'];
  var muscleMassLabels = ['', 'Low', 'Low', 'Normal', 'Slightly High', 'High'];
  var bodyShape = bodyTypeLabels[bodyTypeValue] + ' Body Shape, Muscle Mass: ' + muscleMassLabels[muscleMassValue];
  
  var pri = this.modalInner.querySelector('input[name="priority"]:checked')?.value;
  
  if (!pri) {
    this.showError('Please select your Priority.');
    return;
  }
  
  this.saveToLocalStorage();
  
  // Hide all steps
  this.modalInner.querySelectorAll('[id^="step"]').forEach(function(el) {
    el.style.display = 'none';
  });
  
  // Show loading screen
  this.modalInner.querySelector('#loading').style.display = 'block';
  
  // (Include bust value)
  this.displayLoadingWithData(gender, h, w, a, arm, fit, bodyShape, pri, bust);
  
  // ========== v6.0: Button Integration Display and Background Measurement ==========
  var self = this;
  
  // Update button text to 'measuring' state
  this.updateKFCButtonState('measuring', h, w, null, '0');
  
  // (Fake progress)
  this.startFakeProgress();
  
  // Call API
  setTimeout(function() {
    self.callGeminiAPI(gender, h, w, a, arm, fit, bodyShape, pri, bust);
  }, 1500);
},
    getProductGender: function() {
      var title = document.title || '';
      // Change 'レディース' and 'メンズ' to English checks
      if (title.includes('Women') || title.includes('レディース')) {
        return 'female';
      } else if (title.includes('Men') || title.includes('メンズ')) {
        return 'male';
      }
      return 'unknown';
    },
    
getProductName: function() {
  // Try to get product name from title element
  var nameElem = document.querySelector('.grid-product__title--body') || 
                 document.querySelector('.product-single__title') ||
                 document.querySelector('.name1_');
  
  if (nameElem) {
    var text = nameElem.textContent.trim();
    
    // If contains " - ", get only the part before it
    if (text.includes(' - ')) {
      text = text.split(' - ')[0].trim();
    }
    
    // Remove ★ or (number) patterns
    text = text.replace(/★.*?$/g, '').replace(/\(\d+\).*?$/g, '').trim();
    return text;
  }
  
  // Fallback: try to get from page title
  var pageTitle = document.title;
  if (pageTitle) {
    var titleParts = pageTitle.split('|')[0].trim();
    if (titleParts.includes(' - ')) {
      return titleParts.split(' - ')[0].trim();
    }
    return titleParts;
  }
  
  return 'Product';  // 最終的なフォールバック
},
    
    getProductType: function() {
      var title = document.title || '';
      if (title.includes('Slim Fit') || title.includes('スリムフィット')) {
        return 'slim-fit';
      } else if (title.includes('Regular') || title.includes('レギュラー')) {
        return 'regular';
      } else if (title.includes('Easy Care') || title.includes('イージーケア')) {
        return 'easy-care';
      }
      return 'standard';
    },
    
    confirmAddToCart: function(size) {
      var self = this;
      
      // Show confirmation dialog
      var confirmed = confirm('Add size "' + size + '" to cart? Are you sure?');
      
      if (confirmed) {
        // Sending event to dataLayer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'kfc_add_to_cart',
          'kfc_action': 'add_to_cart',
          'kfc_selected_size': size,
          'product_name': this.getProductName(),
          'product_type': this.getProductType(),
          'ecommerce': {
            'add': {
              'products': [{
                'name': this.getProductName(),
                'id': this.getProductId(),
                'price': this.extractProductPrice?.() || '',
                'variant': size,
                'quantity': 1
              }]
            }
          }
        });

        console.log('[KFC] Event pushed to dataLayer, waiting for GTM to process...');
        
        // Wait 300ms
        // This allows GTM to process the event correctly
        setTimeout(function() {
          console.log('[KFC] GTM processing complete, now adding to cart');
          self.addToCart(size);
        }, 300);
      }
      // Do nothing if user clicks "Cancel"
    },
    
addToCart: function(size) {
  console.log('Attempting to add size to cart:', size);
  
  var self = this;
  try {
    // Find the size select dropdown (name="id")
    var sizeSelect = document.querySelector('select[name="id"]');
    
    if (!sizeSelect) {
      console.error('[KFC] Size select not found');
      this.showToast('Error: Size selector not found');
      return;
    }
    
    console.log('[KFC] Size select found');
    
    // Parse the available options to find the matching size
    var targetOption = null;
    Array.from(sizeSelect.options).forEach(function(option) {
      if (option.textContent.includes(size)) {
        targetOption = option;
      }
    });
    
    if (!targetOption) {
      console.error('[KFC] Size option not found for:', size);
      console.log('[KFC] Available options:', 
        Array.from(sizeSelect.options).map(o => o.textContent)
      );
      this.showToast('Error: Size "' + size + '" not found');
      return;
    }
    
    console.log('[KFC] Found matching option:', targetOption.textContent);
    
    // Set the selected value
    sizeSelect.value = targetOption.value;
    console.log('[KFC] Set size select value to:', targetOption.value);
    
    // Trigger change event to update any dependent UI
    var changeEvent = new Event('change', { bubbles: true });
    sizeSelect.dispatchEvent(changeEvent);
    console.log('[KFC] Dispatched change event');
    
    // Wait a moment for the page to process
    setTimeout(function() {
      // Find the form with action="/cart/add"
      var cartForm = document.querySelector('form[action="/cart/add"]');
      
      if (!cartForm) {
        console.error('[KFC] Cart form not found');
        self.showToast('Error: Cart form not found');
        return;
      }
      
      console.log('[KFC] Found cart form:', cartForm.id);
      
      // Submit the form
      console.log('[KFC] Submitting cart form...');
      cartForm.submit();
      
      console.log('[KFC] Cart form submitted');
      self.showToast('Added "' + size + '" to cart!');
    }, 300);
    
  } catch (e) {
    console.error('[KFC] Error in addToCart:', e);
    this.showToast('Error: ' + e.message);
  }
    },

    
    showToast: function(message) {
      var toast = document.createElement('div');
      toast.textContent = message;
      toast.style.cssText = 'position: fixed; bottom: 20px; left: 50%; transform: translateX(-50%); background: #8B7355; color: white; padding: 14px 28px; border-radius: 24px; font-size: 13px; font-family: "Noto Sans JP", sans-serif; z-index: 10000; box-shadow: 0 4px 12px rgba(0,0,0,0.15); animation: slideUp 0.3s ease; max-width: 300px; text-align: center;';
      
      var style = document.createElement('style');
      style.textContent = '@keyframes slideUp { from { opacity: 0; transform: translateX(-50%) translateY(20px); } to { opacity: 1; transform: translateX(-50%) translateY(0); } }';
      document.head.appendChild(style);
      
      document.body.appendChild(toast);
      
      setTimeout(function() {
        toast.style.animation = 'slideUp 0.3s ease reverse';
        setTimeout(function() {
          document.body.removeChild(toast);
        }, 300);
      }, 2000);
    },
    
    callGeminiAPI: async function(gender, height, weight, age, armLength, fitPreference, bodyShape, priority, bust) {
      var self = this;
      
      try {
        var sizeTableData = this.getSizeTableData();
        var prompt = this.buildPrompt(gender, height, weight, age, armLength, fitPreference, bodyShape, priority, sizeTableData, bust);
        
        console.log('Calling Cloudflare Worker via JSONP...');
        console.log('Prompt length:', prompt.length);
        
        var callbackId = 'kfc_callback_' + Date.now();
        
        window[callbackId] = function(response) {
          console.log('JSONP Response received');
          delete window[callbackId];
          clearTimeout(timeoutId);
          
          var data = response;
          var recommendation = null;
          
          if (data.candidates && data.candidates.length > 0) {
            var candidate = data.candidates[0];
            if (candidate.content && candidate.content.parts && candidate.content.parts.length > 0) {
              recommendation = candidate.content.parts[0].text;
            }
          }
          
if (!recommendation) {
  // Error log output
  console.error("API response error: No text found in candidate content.");
  
  // ✅ エラー表示とフォームに戻す
  self.modalInner.querySelector('#loading').style.display = 'none';
  self.modalInner.querySelector('#step4').style.display = 'block';
  self.showError('An error occurred while analyzing your measurements. Please try again.');
  
  // プログレスバーをリセット
  if (self.progressInterval) {
    clearInterval(self.progressInterval);
  }
  
  // ボタンを初期状態に戻す
  self.updateKFCButtonState('ready', null, null, null, null);
  
  return; // エラー後は処理を終了
}
          
          console.log('Raw recommendation:', recommendation);
          console.log('Raw recommendation length:', recommendation.length);
          
          recommendation = recommendation.replace(/```json\n?/g, '')
                                 .replace(/```\n?/g, '')
                                 .replace(/`/g, '')
                                 .trim();

          var jsonStart = recommendation.indexOf('{');
          var jsonEnd = recommendation.lastIndexOf('}');

          if (jsonStart > -1 && jsonEnd > jsonStart) {
            recommendation = recommendation.substring(jsonStart, jsonEnd + 1);
          }
          
          // Check for correct JSON format
          if (!recommendation.startsWith('{')) {
            console.error('Response does not start with {:', recommendation.substring(0, 100));
            throw new Error('Invalid JSON format: Response should start with {');
          }
          
          console.log('Cleaned recommendation:', recommendation);
          console.log('Cleaned recommendation length:', recommendation.length);
          
          self.displayResults(recommendation);
        };
        
        var url = GAS_ENDPOINT_URL + '?prompt=' + encodeURIComponent(prompt) + '&callback=' + callbackId;
        
     var script = document.createElement('script');
script.src = url;
script.onerror = function() {
  console.error('JSONP request failed');
  self.showError('An error occurred: Network request failed. Please try again.');
  self.modalInner.querySelector('#loading').style.display = 'none';
  self.modalInner.querySelector('#step4').style.display = 'block';
  
  // プログレスバーをリセット
  if (self.progressInterval) {
    clearInterval(self.progressInterval);
  }
  
  // ボタンを初期状態に戻す
  self.updateKFCButtonState('ready', null, null, null, null);
  
  delete window[callbackId];
  clearTimeout(timeoutId);
};

// (Handle slow Gemini API)
var timeoutId = setTimeout(function() {
  console.error('JSONP request timeout (60s)');
  self.showError('The request took too long. Please try again.');
  self.modalInner.querySelector('#loading').style.display = 'none';
  self.modalInner.querySelector('#step4').style.display = 'block';
  
  // プログレスバーをリセット
  if (self.progressInterval) {
    clearInterval(self.progressInterval);
  }
  
  // ボタンを初期状態に戻す
  self.updateKFCButtonState('ready', null, null, null, null);
  
  delete window[callbackId];
  if (script.parentNode) {
    script.parentNode.removeChild(script);
  }
}, 60000);

document.body.appendChild(script);

} catch (error) {
  console.error('API Error:', error);
  self.showError('An error occurred: ' + error.message + ' Please try again.');
  self.modalInner.querySelector('#loading').style.display = 'none';
  self.modalInner.querySelector('#step4').style.display = 'block';
  
  // プログレスバーをリセット
  if (self.progressInterval) {
    clearInterval(self.progressInterval);
  }
  
  // ボタンを初期状態に戻す
  self.updateKFCButtonState('ready', null, null, null, null);
}
    },
    
    
    
    
displayLoadingWithData: function(gender, height, weight, age, armLength, fitPreference, bodyShape, priority, bust) {
  var loadingInfoHTML = '<div style="font-size:10px; color:#999; font-weight:700; margin-bottom:8px; text-transform:uppercase; letter-spacing:0.6px;">Measurement Data</div>';
  
  loadingInfoHTML += '<div style="display:flex; flex-direction:column; gap:8px; font-size:11px;">';
  
  loadingInfoHTML += '<div style="display:flex; justify-content:space-between; padding:6px 0; border-bottom:1px solid #E8DDD3;">';
  loadingInfoHTML += '<span style="font-weight:600; color:#6B5547;">Gender:</span>';
  loadingInfoHTML += '<span style="color:#333;">' + gender + '</span>';
  loadingInfoHTML += '</div>';
  
  loadingInfoHTML += '<div style="display:flex; justify-content:space-between; padding:6px 0; border-bottom:1px solid #E8DDD3;">';
  loadingInfoHTML += '<span style="font-weight:600; color:#6B5547;">Height:</span>';
  // ✅ ここで単位を表示するだけ
  if (this.currentUnit === 'imperial') {
    var feet = Math.floor(height / 30.48);
    var inches = Math.round((height - feet * 30.48) / 2.54);
    loadingInfoHTML += '<span style="color:#333;">' + feet + '\' ' + inches + '" (in)</span>';
  } else {
    loadingInfoHTML += '<span style="color:#333;">' + height + ' cm</span>';
  }
  loadingInfoHTML += '</div>';
  
  loadingInfoHTML += '<div style="display:flex; justify-content:space-between; padding:6px 0; border-bottom:1px solid #E8DDD3;">';
  loadingInfoHTML += '<span style="font-weight:600; color:#6B5547;">Weight:</span>';
  // ✅ ここで単位を表示するだけ
  if (this.currentUnit === 'imperial') {
    var weightLb = Math.round(weight * 2.20462 * 10) / 10;
    loadingInfoHTML += '<span style="color:#333;">' + weightLb + ' lb</span>';
  } else {
    loadingInfoHTML += '<span style="color:#333;">' + weight + ' kg</span>';
  }
  loadingInfoHTML += '</div>';
  
  // If Female, display bust
  if (gender === 'Female' && bust) {
    loadingInfoHTML += '<div style="display:flex; justify-content:space-between; padding:6px 0; border-bottom:1px solid #E8DDD3;">';
    loadingInfoHTML += '<span style="font-weight:600; color:#6B5547;">Bust:</span>';
    // ✅ ここで単位を表示するだけ
    if (this.currentUnit === 'imperial') {
      var bustIn = Math.round(bust / 2.54 * 10) / 10;
      loadingInfoHTML += '<span style="color:#333;">' + bustIn + ' in</span>';
    } else {
      loadingInfoHTML += '<span style="color:#333;">' + bust + ' cm</span>';
    }
    loadingInfoHTML += '</div>';
  }
  
  loadingInfoHTML += '<div style="display:flex; justify-content:space-between; padding:6px 0; border-bottom:1px solid #E8DDD3;">';
  loadingInfoHTML += '<span style="font-weight:600; color:#6B5547;">Age:</span>';
  loadingInfoHTML += '<span style="color:#333;">' + age + '</span>';
  loadingInfoHTML += '</div>';
  
  loadingInfoHTML += '<div style="display:flex; justify-content:space-between; padding:6px 0; border-bottom:1px solid #E8DDD3;">';
  loadingInfoHTML += '<span style="font-weight:600; color:#6B5547;">Arm Length:</span>';
  loadingInfoHTML += '<span style="color:#333;">' + armLength + '</span>';
  loadingInfoHTML += '</div>';
  
  loadingInfoHTML += '<div style="display:flex; justify-content:space-between; padding:6px 0; border-bottom:1px solid #E8DDD3;">';
  loadingInfoHTML += '<span style="font-weight:600; color:#6B5547;">Body Shape:</span>';
  loadingInfoHTML += '<span style="color:#333;">' + bodyShape.replace('Body Shape、Muscle Mass:', ' | Muscle Mass:').replace('SlightlyLarger', 'Slightly Larger') + '</span>';
  loadingInfoHTML += '</div>';
  
  loadingInfoHTML += '<div style="display:flex; justify-content:space-between; padding:6px 0;">';
  loadingInfoHTML += '<span style="font-weight:600; color:#6B5547;">Priority:</span>';
  loadingInfoHTML += '<span style="color:#333;">' + priority + '</span>';
  loadingInfoHTML += '</div>';
  
  loadingInfoHTML += '</div>';
  
  var loadingInfoContainer = this.modalInner.querySelector('#loadingInfo');
  if (loadingInfoContainer) {
    loadingInfoContainer.innerHTML = loadingInfoHTML;
    loadingInfoContainer.style.display = 'block';
  }

  var resultLoadingInfoContainer = this.modalInner.querySelector('#resultLoadingInfo');
  if (resultLoadingInfoContainer) {
    resultLoadingInfoContainer.innerHTML = loadingInfoHTML;
    resultLoadingInfoContainer.style.display = 'block';
  }
},
    
    // ========== v5: Progress Bar Methods ==========
    
    // Start fake progress animation
    startFakeProgress: function() {
      var self = this;
      var progress = 0;
      var progressBar = document.getElementById('progressBar');
      var progressPercent = document.getElementById('progressPercent');
      
      // (Extract from display)
      var kfcButton = document.querySelector('.kfc-fit-finder-btn') ||
                      document.querySelector('#kfc-btn-wrapper');
      var height = 0, weight = 0;
      
      if (kfcButton && kfcButton.innerHTML.includes('cm')) {
        var match = kfcButton.innerHTML.match(/(\d+)cm\s+(\d+)kg/);
        if (match) {
          height = match[1];
          weight = match[2];
        }
      }
      
      if (!progressBar) {
        console.warn('[KFC v6] Progress bar not found');
        return;
      }
      
      // (Max up to 85%)
      this.progressInterval = setInterval(function() {
        progress += Math.random() * (85 - progress) * 0.05; // Deceleration function
        progress = Math.min(progress, 85);
        
        progressBar.style.width = Math.floor(progress) + '%';
        progressPercent.textContent = Math.floor(progress) + '%';
        
        // v6.0: Update button percentage too
        self.updateKFCButtonState('measuring', height, weight, null, Math.floor(progress));
        
        // console.log('[KFC v6] Progress: ' + Math.floor(progress) + '%'); // Removed verbose logging
      }, 300);
    },
    
    // (To 100%)
    completeProgress: function() {
      if (this.progressInterval) {
        clearInterval(this.progressInterval);
      }
      
      var progressBar = document.getElementById('progressBar');
      var progressPercent = document.getElementById('progressPercent');
      
      if (progressBar && progressPercent) {
        progressBar.style.width = '100%';
        progressPercent.textContent = '100%';
        console.log('[KFC v5] Progress completed: 100%');
      }
    },
    
    // ========== v6.0: Button Text Integration Display ==========
    updateKFCButtonState: function(state, height, weight, recommendedSize, progress) {
      // Find the "Find your perfect size" button on the page
      var kfcButton = document.querySelector('.kfc-fit-finder-btn') ||
                      document.querySelector('[data-kfc-button="true"]') || 
                      document.querySelector('button[data-analytics="kfc_button"]') ||
                      document.querySelector('#kfc-btn-wrapper') ||
                      Array.from(document.querySelectorAll('button, div[class*="kfc"]')).find(btn => 
                        btn.textContent.includes('ピッタリ') || 
                        btn.textContent.includes('Measurement') ||
                        btn.textContent.includes('Find Your Perfect Fit') // Added for safety
                      );
      
      if (!kfcButton) {
        console.log('[KFC v6] KFC button not found on page');
        return;
      }
      
if (state === 'measuring') {
  // Measuring state
  var progressPercent = progress || '0';
  var html = '<div style="font-size: 13px;">Measuring size... ' + 
             '<span style="font-size: 15px; color: #FFF; margin-top: 2px; font-weight:bold;">' + progressPercent + '%'+'</span></div>';
        kfcButton.innerHTML = html;
        kfcButton.style.opacity = '0.7';
        kfcButton.style.pointerEvents = 'none';
        // console.log('[KFC v6] Button state: measuring'); // Removed verbose logging
      } else if (state === 'result') {
        // Measurement complete state
        var resultHtml = '<div style="font-size: 13px;">Recommended Size：<span style="font-weight: 700; color: #D4A574; font-size: 15px;">' + recommendedSize + '</span></div>';
        kfcButton.innerHTML = resultHtml;
        kfcButton.style.opacity = '1';
        kfcButton.style.pointerEvents = 'auto';
        // console.log('[KFC v6] Button state: result'); // Removed verbose logging
      } else if (state === 'ready') {
        // Revert to Default state
        kfcButton.innerHTML = 'Find Your Perfect Fit'; // Translated from 'あなたにぴったりのサイズを探す'
        kfcButton.style.opacity = '1';
        kfcButton.style.pointerEvents = 'auto';
        console.log('[KFC v6] Button state: ready');
      }
    },
    
    // ========== v6.0: Bubble Notification Display ==========
    showBubbleNotification: function(message, targetButton) {
      // Remove existing notification if present
      var existingBubble = document.getElementById('kfc-bubble-notification');
      if (existingBubble) {
        existingBubble.remove();
      }
      
      var bubble = document.createElement('div');
      bubble.id = 'kfc-bubble-notification';
      bubble.style.cssText = `
        position: fixed;
        z-index: 9998;
        background: linear-gradient(135deg, #4CAF50, #66BB6A);
        color: white;
        padding: 12px 16px;
        border-radius: 12px;
        font-size: 13px;
        font-weight: 600;
        box-shadow: 0 4px 12px rgba(0,0,0,0.2);
        font-family: 'Noto Sans JP', 'Segoe UI', sans-serif;
        animation: kfc-bubble-pop 0.4s ease-out;
        max-width: 240px;
        text-align: center;
      `;
      
      bubble.textContent = message;
      document.body.appendChild(bubble);
      
      // Get button position and place notification above it
      if (targetButton) {
        var rect = targetButton.getBoundingClientRect();
        bubble.style.bottom = (window.innerHeight - rect.top + 10) + 'px';
        bubble.style.left = (rect.left + rect.width / 2 - 120) + 'px'; // Center alignment
      } else {
        bubble.style.bottom = '20px';
        bubble.style.left = '50%';
        bubble.style.transform = 'translateX(-50%)';
      }
      
      // Animation definition
      if (!document.getElementById('kfc-bubble-style')) {
        var style = document.createElement('style');
        style.id = 'kfc-bubble-style';
        style.textContent = `
          @keyframes kfc-bubble-pop {
            0% { 
              opacity: 0; 
              transform: scale(0.6) translateY(10px);
            }
            100% { 
              opacity: 1; 
              transform: scale(1) translateY(0);
            }
          }
        `;
        document.head.appendChild(style);
      }
      
      console.log('[KFC v6] Bubble notification shown');
      
      // Auto close after 3 seconds
      setTimeout(function() {
        bubble.style.opacity = '0';
        bubble.style.transition = 'opacity 0.5s ease';
        setTimeout(function() {  
          if (bubble.parentNode) {
            bubble.remove();  
          }
        }, 500);
      }, 3000);
    },
    
    // (Empty implementation for backward compatibility) ==========
    showFloatingBadge: function(height, weight) {
      // Deprecated in v6.0
      console.log('[KFC v6] showFloatingBadge is deprecated, use updateKFCButtonState instead');
    },
    
    // (Backward compatibility) ==========
    completeFloatingBadge: function() {
      // (Called inside displayResults method)
      console.log('[KFC v6] completeFloatingBadge is deprecated');
    },
    
    // (Bubble version) ==========
    notifyCompletion: function(recommendedSize) {
      // v6.0 uses only bubble notification
      var targetButton = document.querySelector('.kfc-fit-finder-btn') ||
                           document.querySelector('#kfc-btn-wrapper') ||
                           document.querySelector('[data-kfc-button="true"]') || 
                           document.querySelector('button[data-analytics="kfc_button"]') ||
                           Array.from(document.querySelectorAll('button')).find(btn => 
                             btn.textContent.includes('ピッタリ')
                           );
      
      this.showBubbleNotification('✓ Measurement complete!', targetButton);
      console.log('[KFC v6] Completion notification shown - Recommended size: ' + recommendedSize);
    },
    
    // (Fixed in v6.0) ==========
displayResults: function(recommendation) {
  try {
    // ✅ エラーメッセージをクリア
    this.modalInner.querySelector('#errorMessage').style.display = 'none';
    
    var data = JSON.parse(recommendation);
        console.log('Parsed JSON data:', data);

        // ✅ v6.0: Complete progress
        this.completeProgress();
        
        // ✅ v6.0: Get recommended size
        var recommendedSize = (data.recommendation1 && data.recommendation1.size) ? data.recommendation1.size : 'No Size Recommended';
        
        // (Display recommended size)
        this.updateKFCButtonState('result', null, null, recommendedSize, null);
        
        // ✅ v6.0: Send bubble notification
        this.notifyCompletion(recommendedSize);

      // Sending event to dataLayer
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'kfc_result_displayed',
        'kfc_action': 'result_displayed',
        'kfc_has_recommendation': data.status !== 'no_recommendation',
        'kfc_recommended_size_1': data.recommendation1?.size || 'none',
        'kfc_recommend_degree_1': data.recommendation1?.recommendDegree || 0,
        'kfc_recommended_size_2': data.recommendation2?.size || 'none',
        'kfc_recommend_degree_2': data.recommendation2?.recommendDegree || 0,
        'product_name': this.getProductName(),
        'product_type': this.getProductType()
      });
        
        // (With expiry, supports multiple products)
        var currentProductId = this.getProductId();
        this.saveCacheWithExpiry(currentProductId, data);
        console.log('Saved result to cache with expiry');
        
// Display product name in title
var productName = this.getProductName();
this.modalInner.querySelector('#resultTitle').textContent = productName + ' Size Recommendation';
        
        var html = "";
        
        // No recommendation case
        if (data.status === 'no_recommendation') {
          html = '<div class="kfc-no-recommendation">' +
                 '<div class="kfc-no-recommendation-emoji">😔</div>' +
                 '<div class="kfc-no-recommendation-title">We apologize</div>' +
                 '<div class="kfc-no-recommendation-text">' +
                 'Unfortunately, we could not find an appropriate size for you in this shirt\'s size range.<br><br>' +
                 'Please consider trying another product or contacting our staff.' +
                 '</div>' +
                 '</div>';
        } else {
          // Case with recommendation
 var buildCard = function(rec, isSecondary) {
  if (!rec || !rec.size) return '';
  
  var recommendDegree = rec.recommendDegree || 0;
  var scores = rec.scores || {};
  var reasons = rec.reasons || {};
  
  var card = '<div class="kfc-result-card' + (isSecondary ? ' secondary' : '') + '">';
  
  // ===== 新レイアウト: 縦並び表示 =====
  card += '<div style="width: 100%;">';
  
  // サイズを大きく表示
  card += '<div class="kfc-result-size" style="margin-bottom: 20px;">' + rec.size + '</div>';
  
  // Recommendation Degree セクション
  card += '<div style="margin-bottom: 24px;">';
  card += '<div class="kfc-meter-label" style="margin-bottom: 10px;">Recommendation Degree</div>';
  
  card += '<div style="display: flex; align-items: center; gap: 16px;">';
  card += '<div style="font-size: 20px; font-weight: 700; color: #8B7355; min-width: 50px; text-align: right;">' + recommendDegree + '%</div>';
  
  card += '<div style="flex: 1; min-height: 24px;">';
  card += '<div class="kfc-meter-bar"><div class="kfc-meter-fill" style="--meter-width:' + recommendDegree + '%;"></div></div>';
  card += '</div>';
  card += '</div>';
  card += '</div>';
  
  card += '</div>';
			  
			  
			  
			  
			  
			  
            

            
            // (Exclude length and overall)
            card += '<div class="kfc-scores">';
            
            // Score key English name mapping
            var scoreLabels = {
              'neck': 'Neck',
              'shoulderWidth': 'Shoulder',
              'shoulder': 'Shoulder',
              'armLength': 'Sleeve Length',
              'sleeve': 'Sleeve Length',
              'chestCircumference': 'Chest',
              'chest': 'Chest',
              'waistCircumference': 'Waist', // Changed '胴囲' to 'Waist'
              'waist': 'Waist',              // Changed '胴囲' to 'Waist'
              'sleeveLength': 'Sleeve',      // Changed '袖丈' to 'Sleeve'
              'bust': 'Bust',
              'hemCircumference': 'Hem'
            };
            
            // Dynamically display scores excluding length and overall
            for (var key in scores) {
              // Exclude length and overall
              if (key === 'length' || key === 'overall' || key === 'total' || key === 'dressingLength' || key === 'sleeveLength') {
                continue;
              }
              
              // Note: Logic to check/correct score values (if not number or >10) is not implemented here, using raw values
              var value = scores[key];
              if (typeof value !== 'number' || value < 0 || value > 10) {
                  console.warn(`Score for ${key} is invalid: ${value}. Using raw value.`);
              }
              
              var label = scoreLabels[key] || key;
              
              card += '<div class="kfc-score-item">';
              card += '<div class="kfc-score-label">' + label + '</div>';
              card += '<div class="kfc-score-value">' + value + '</div>';
              card += '<div class="kfc-score-max">/10</div>';
              card += '</div>';
            }
            
            card += '</div>';
            
            card += '<div class="kfc-reasons">';
            card += '<div class="kfc-reason-title">Recommendation Reason</div>';
            card += '<div class="kfc-reason-text">' + (reasons.overall || 'No recommendation reason available') + '</div>';
            card += '</div>';
            
            // (Text button)
            card += '<div style="margin-top: 16px; text-align: center;">';
            card += '<button class="kfc-add-to-cart-btn" data-size="' + rec.size + '" onclick="window.KFCSizeMeasurement.confirmAddToCart(\'' + rec.size + '\')" style="padding: 12px 28px; background: linear-gradient(135deg, #8B7355 0%, #9B8B7F 100%); color: white; border: none; border-radius: 24px; font-weight: 600; cursor: pointer; font-size: 14px; font-family: \'Noto Sans JP\', sans-serif; transition: all 0.3s ease; width: 100%; box-sizing: border-box;">Add this size to cart</button>';
            card += '</div>';
            card += '</div>';
            
            return card;
          };
          
          if (data.recommendation1) html += buildCard(data.recommendation1, false);
          if (data.recommendation2) html += buildCard(data.recommendation2, true);
          
          // Notes and link at the bottom of the results page
          html += '<div style="margin-top: 30px; padding: 16px; background: #f9f7f4; border-radius: 8px; border-left: 4px solid #8B7355;">';
          html += '<div style="font-size: 12px; color: #666; line-height: 1.6;">';
          html += 'This tool uses AI-generated statistical data for sizing.<br>It does not guarantee a 100% accurate fit for you.';
          html += '</div>';
          html += '</div>';
        }
        
        this.modalInner.querySelector('#resultContent').innerHTML = html;
        
        // Completely hide all steps
        this.modalInner.querySelectorAll('[id^="step"]').forEach(function(el) {
          el.style.display = 'none';
          el.classList.remove('active');
        });
        
        // Completely hide loading screen too
        this.modalInner.querySelector('#loading').style.display = 'none';
        this.modalInner.querySelector('#loadingInfo').innerHTML = '';
        
        // Display only results
        this.modalInner.querySelector('#results').style.display = 'block';
        
      } catch (error) {
        console.error("Parse error:", error);
        this.showError('Failed to display results: ' + error.message); // Translated error message
        this.modalInner.querySelector('#loading').style.display = 'none';
        this.modalInner.querySelector('#step4').style.display = 'block';
      }
    },
    
backToForm: function() {
  var self = this;
  
  // ✅ エラーメッセージをクリア
  this.modalInner.querySelector('#errorMessage').style.display = 'none';
  
  // Hide results screen
      
      // Hide results screen
      this.modalInner.querySelector('#results').style.display = 'none';
      
      // Reset all step styles and remove active class
      this.modalInner.querySelectorAll('[id^="step"]').forEach(function(el) {
        el.style.display = '';  // Reset inline style
        el.classList.remove('active');
      });
      
      // Display STEP1 as active
      this.currentStep = 1;
      var step1 = this.modalInner.querySelector('#step1');
      if (step1) {
        step1.classList.add('active');
        console.log('backToForm: STEP1 activated');
      }
      
      this.updateProgress();
      
      // Restore previous input values from localStorage
      this.restoreFromLocalStorage();
      
      // Clear error message
      this.modalInner.querySelector('#errorMessage').style.display = 'none';
      
      // Reset button state (Added v6.0)
      this.updateKFCButtonState('ready', null, null, null, null);
    },
    
    showError: function(message) {
      var errorEl = this.modalInner.querySelector("#errorMessage");
      errorEl.textContent = message;
      errorEl.style.display = 'block';
    },
    
saveToLocalStorage: function() {
  // ✅ 常にメトリック（cm/kg）で保存
  var height, weight, bust;
  
  if (this.currentUnit === 'imperial') {
    // インペリアル → メトリックに変換して保存
    var feet = parseFloat(this.modalInner.querySelector('#height-feet').value) || 0;
    var inches = parseFloat(this.modalInner.querySelector('#height-inches').value) || 0;
    var totalInches = feet * 12 + inches;
    height = Math.round(totalInches * 2.54 * 10) / 10;
    
    var weightLb = parseFloat(this.modalInner.querySelector('#weight').value) || 0;
    weight = Math.round(weightLb / 2.20462 * 10) / 10;
    
    var bustIn = parseFloat(this.modalInner.querySelector('#bust')?.value);
    bust = bustIn ? Math.round(bustIn * 2.54 * 10) / 10 : '';
  } else {
    // メトリックはそのまま
    height = this.modalInner.querySelector('#height').value;
    weight = this.modalInner.querySelector('#weight').value;
    bust = this.modalInner.querySelector('#bust')?.value || '';
  }
  
  var data = {
    gender: this.modalInner.querySelector('input[name="gender"]:checked')?.value || '',
    height: height,
    weight: weight,
    age: this.modalInner.querySelector('#age').value,
    bust: bust,
        armLength: this.modalInner.querySelector('input[name="armLength"]:checked')?.value || '',
        bodyTypeValue: this.modalInner.querySelector('#bodyType')?.value || '3',
        muscleMassValue: this.modalInner.querySelector('#muscleMass')?.value || '3',
        fitPreference: null, 
        priority: this.modalInner.querySelector('input[name="priority"]:checked')?.value || ''
      };
      
      // Removed logic related to "Other" option
      
      localStorage.setItem('kfc-measurement-data', JSON.stringify(data));
      localStorage.setItem('kfc-measurement-product-id', this.getProductId());
      console.log('Saved to localStorage:', data);
    },
    
    restoreFromLocalStorage: function() {
      var self = this;
      var savedData = localStorage.getItem('kfc-measurement-data');
      if (!savedData) return;
      
      var data = JSON.parse(savedData);
      console.log('Restored from localStorage:', data);
      
      setTimeout(function() {
        // Restore Gender
        if (data.gender) {
          var genderRadio = self.modalInner.querySelector('input[name="gender"][value="' + data.gender + '"]');
          if (genderRadio) {
            genderRadio.checked = true;
            var genderOption = genderRadio.closest('.kfc-radio-option');
            genderOption.classList.add('selected');
            
            // (Call logic from selectRadio function)
            var bustField = self.modalInner.querySelector('#bust-field');
            if (data.gender === 'Female' && bustField) {
              bustField.style.display = 'flex';
            } else if (data.gender === 'Male' && bustField) {
              bustField.style.display = 'none';
            }
          }
        }
        
// ✅ 保存されたデータは常にメトリック（cm/kg）なので、現在の単位に応じて変換
if (data.height) {
  var heightCm = parseFloat(data.height);
  if (self.currentUnit === 'imperial') {
    // cm → ft/in に変換
    var totalInches = heightCm / 2.54;
    var feet = Math.floor(totalInches / 12);
    var inches = Math.round((totalInches % 12) * 10) / 10;
    self.modalInner.querySelector('#height-feet').value = feet;
    self.modalInner.querySelector('#height-inches').value = inches;
  } else {
    self.modalInner.querySelector('#height').value = data.height;
  }
}

if (data.weight) {
  var weightKg = parseFloat(data.weight);
  if (self.currentUnit === 'imperial') {
    // kg → lb に変換
    var weightLb = Math.round(weightKg * 2.20462 * 10) / 10;
    self.modalInner.querySelector('#weight').value = weightLb;
  } else {
    self.modalInner.querySelector('#weight').value = data.weight;
  }
}

if (data.age) self.modalInner.querySelector('#age').value = data.age;

// ✅ Bust も単位変換が必要
if (data.bust) {
  var bustCm = parseFloat(data.bust);
  if (self.currentUnit === 'imperial' && bustCm) {
    // cm → in に変換
    var bustIn = Math.round(bustCm / 2.54 * 10) / 10;
    self.modalInner.querySelector('#bust').value = bustIn;
  } else {
    self.modalInner.querySelector('#bust').value = data.bust;
  }
}
        if (data.armLength) {
          var armRadio = self.modalInner.querySelector('input[name="armLength"][value="' + data.armLength + '"]');
          if (armRadio) {
            armRadio.checked = true;
            armRadio.closest('.kfc-radio-option').classList.add('selected');
          }
        }
        
        // (New addition)
        if (data.bodyTypeValue) {
          var bodyTypeSlider = self.modalInner.querySelector('#bodyType');
          if (bodyTypeSlider) {
            bodyTypeSlider.value = data.bodyTypeValue;
            bodyTypeSlider.dispatchEvent(new Event('input'));
          }
        }
        
        if (data.muscleMassValue) {
          var muscleMassSlider = self.modalInner.querySelector('#muscleMass');
          if (muscleMassSlider) {
            muscleMassSlider.value = data.muscleMassValue;
            muscleMassSlider.dispatchEvent(new Event('input'));
          }
        }
        
        // Restore priority
        if (data.priority) {
          var priorityValues = document.querySelectorAll('input[name="priority"]');
          for (var i = 0; i < priorityValues.length; i++) {
            // "Other" option removed, only restore if value matches
            if (priorityValues[i].value === data.priority) {
              priorityValues[i].checked = true;
              priorityValues[i].closest('.kfc-radio-option').classList.add('selected');
              break;
            }
          }
        }
        
      }, 100);
    },
    
    getSizeTableData: function() {
      console.log('=== Size Table Extraction Start ===');
      
      var gender = this.getProductGender();
      
      // Try new structure first (.ks-chart-individual)
      var sizeContainer = document.querySelector('.ks-chart-individual') ||
                          document.querySelector('#ipop_size') ||
                          document.querySelector('.size-container');
      
      console.log('Gender:', gender);
      console.log('Size container found:', !!sizeContainer);
      
      if (sizeContainer) {
        console.log('Extracting size table from page...');
        
        var data = '';
        var headers = [];
        var items = [];
        
        // New structure: .ks-chart-individual table
        var table = sizeContainer.querySelector('.ks-table');
        if (table) {
          var headerRow = table.querySelector('tr:first-child');
          if (headerRow) {
            var headerCells = headerRow.querySelectorAll('td.ks-table-header-cell');
            headerCells.forEach(function(h) {
              headers.push(h.textContent.trim());
            });
          }
          
          var dataRows = table.querySelectorAll('tr:not(:first-child)');
          dataRows.forEach(function(row) {
            var cells = row.querySelectorAll('td');
            var rowData = [];
            cells.forEach(function(cell) {
              rowData.push(cell.textContent.trim());
            });
            items.push(rowData);
          });
        } else {
          // Fallback to old structure
          var oldItems = sizeContainer.querySelectorAll('.size-tbl-item');
          var headerRow = sizeContainer.querySelector('.size-tbl-left');
          if (headerRow) {
            var headerDivs = headerRow.querySelectorAll('.ttl');
            headerDivs.forEach(function(h) {
              headers.push(h.textContent.trim());
            });
          }
          
          oldItems.forEach(function(item) {
            var divs = item.querySelectorAll('div');
            var row = [];
            for (var i = 0; i < headers.length && i < divs.length; i++) {
              row.push(divs[i]?.textContent?.trim() || '');
            }
            if (row.length > 0 && row[0]) {
              items.push(row);
            }
          });
        }
        
        console.log('Headers found:', headers.length);
        console.log('Data rows found:', items.length);
        
        // Build data string
        if (headers.length > 0) {
          data = headers.join(' | ') + '\n';
          items.forEach(function(row) {
            if (row.length > 0) {
              data += row.join(' | ') + '\n';
            }
          });
        } else {
          // Default headers
          data = 'Size | Neck | Sleeve | Chest | Waist | Yoke | Length\n';
          items.forEach(function(row) {
            if (row.length > 0) {
              data += row.join(' | ') + '\n';
            }
          });
        }
        
        // Get size table notes
        var sizeNotes = '';
        var notesDiv = sizeContainer.querySelector('.ks-html-content') ||
                       sizeContainer.querySelector('.size-txt');
        if (notesDiv) {
          var paragraphs = notesDiv.querySelectorAll('p, li');
          var noteTexts = [];
          paragraphs.forEach(function(p) {
            var text = p.textContent.trim();
            if (text && text.length > 0) {
              noteTexts.push(text);
            }
          });
          
          if (noteTexts.length > 0) {
            sizeNotes = '\n\n## Size Table Notes ##\n' + noteTexts.join('\n');
          }
        }
        
        console.log('Extracted size table:', data);
        console.log('Extracted notes:', sizeNotes);
        
        this.sizeTableHeaders = headers;
        
        // Combine table and notes
        var fullData = data + sizeNotes;
        
        if (fullData.split('\n').length > 2) {
          return fullData;
        }
      }
      
      console.log('Warning: Could not extract size table from page');
      console.log('=== Size Table Extraction End ===');
      return '';
    },
    
buildPrompt: function(userGender, height, weight, age, armLength, fitPreference, bodyShape, priority, sizeTableData, bust) {
  // ✅ 修正：sanity check - 物理的に不可能な値をフィルタ
  if (height > 210 || height < 140) {
    console.error('[KFC] Invalid height detected:', height);
    height = 170;  // デフォルト値にリセット
  }
  // ★★★ 修正：weight は kg 単位なので、範囲を変更 ★★★
  if (weight > 160 || weight < 30) {
    console.error('[KFC] Invalid weight detected:', weight);
    weight = 65;  // デフォルト値にリセット
  }
      var productType = this.getProductType();
      
      // Prioritize user input Gender
      var genderText = userGender === 'Female' ? 'Female' : 'Male';
      var adultText = userGender === 'Female' ? 'Adult Female' : 'Adult Male'; // Translated '成人女性/男性'
      // Translated product types from title check
      var productTypeText = productType === 'slim-fit' ? 'Slim-Fit' : productType === 'regular' ? 'Regular' : productType === 'easy-care' ? 'Easy-Care' : 'Standard';
      
      // fitPreference is removed in v71, null check for compatibility
      var fitPreferenceDetail = fitPreference;
      if (fitPreference === 'タイトフィット') {
        fitPreferenceDetail = 'Tight fit (snug feel)';
      } else if (fitPreference === 'Normal') {
        fitPreferenceDetail = 'Normal (average feel)';
      } else if (fitPreference === 'ルーズフィット') {
        fitPreferenceDetail = 'Loose fit (comfortable feel)';
      }
      
      var headers = this.sizeTableHeaders || [];
      // (Slice: from 1st to 1st-to-last)
      var headerText = headers.length > 1 ? headers.slice(1, headers.length - 1).join(', ') : 'specified size attributes';
      
      console.log('Headers for prompt:', headers);
      console.log('Header text:', headerText);
      
      // (Handle new format "XXX Body Shape, Muscle Mass: YYY")
      var bodyTypeLabel = 'Normal';
      var muscleMassLabel = 'Normal';
      
      if (bodyShape) {
        // New format: "Normal Body Shape, Muscle Mass: Normal"
        if (bodyShape.includes(' Body Shape, Muscle Mass: ')) {
          var parts = bodyShape.split(' Body Shape, Muscle Mass: ');
          if (parts.length === 2) {
            bodyTypeLabel = parts[0].trim();
            muscleMassLabel = parts[1].trim();
          }
        }
        // (Maintain compatibility with old format)
        else if (bodyShape.includes('で、Muscle Massは')) { // Japanese old format
          var parts = bodyShape.split('で、Muscle Massは');
          if (parts.length === 2) {
            bodyTypeLabel = parts[0].trim();
            muscleMassLabel = parts[1].replace('です。', '').trim();
          }
        }
      }
      
      // Translated Prompt
      var prompt = 'You are an excellent fitter at a specialty store handling \'' + productTypeText + ' products\'. Please answer the following questions.\n\n';
      prompt += '## Customer Information ##\n';
      prompt += 'I am an ' + adultText + ' who is ' + height + 'cm tall, weighs ' + weight + 'kg, and is ' + age + ' years old.\n';
      
      // If Female, add bust information
      if (userGender === 'Female' && bust) {
        prompt += 'My bust size is ' + bust + 'cm.\n'; // Translated 'バストサイズは'
      }
      
      prompt += 'Subjectively, my Arm Length is ' + armLength + '.\n';
      prompt += 'I have a ' + bodyTypeLabel + ' Body Shape, and my Muscle Mass is ' + muscleMassLabel + '.\n'; // Translated body shape details
      prompt += 'My top priority for this product is: "' + priority + '".\n\n'; // Translated '特に重要視しているのは'
      
      // Replaced with simplified sizing guidance
      prompt += '## Size Selection Criteria ##\n';
      prompt += 'Please base your recommendation on the size chart data, applying a reduction of 2% for potential washing shrinkage, and adjusting the fit according to the customer\'s Body Shape details.\n'; // Translated/rephrased criteria
      prompt += '※If shrinkage is mentioned in the notes, prioritize that value.\n\n'; // Translated Note
      
      prompt += '## Size Chart ##\n';
      prompt += sizeTableData + '\n\n';
      
          prompt += '## Proposal Format ##\n';
      prompt += 'Please use the heading: **Shirt Size Recommendation**.\n';
      prompt += 'Based on the [Size Selection Criteria] above, please propose the most suitable size.\n';
prompt += 'Please suggest 2 sizes with different neck measurements whenever possible (e.g., 39 and 40). If only 1 suitable size exists, you may suggest only one, but try to avoid this.\n';
      prompt += 'Evaluate the Recommendation Degree for both sizes on a scale of 10 to 100. The sum of the Recommendation Degrees should be 100.\n';
      prompt += 'Present the most recommended size first.\n';
prompt += '**If there is a significant discrepancy between the body size and the provided size chart:**\n';      prompt += 'Please return: {"status":"no_recommendation","message":"reason in English"}\n';
      prompt += '**If a Recommended Size exists:**\n';
      prompt += '1. For each item of "' + headerText + '", evaluate the suitability on a scale of 1 to 10. However, avoid giving a score of 10 unless absolutely necessary.\n';
      prompt += '   The unit is "cm (in)" - always use both centimeters and inches in your evaluation.\n';
prompt += '2. Describe the recommendation reason for each item specifically. Keep the overall reason customer-focused and concise in English (max 250 characters). Focus on benefits and how this size meets their priority: "' + priority + '". Minimize technical measurements.\n';
	  prompt += '3. Return the result in JSON format. Please use the following structure (reasons content must be all in English):\n';
      prompt += '{"recommendation1":{"size":"XXX","recommendDegree":70,"scores":{...},"reasons":{"overall":"reason in English"}},\n';
      prompt += '"recommendation2":{"size":"YYY","recommendDegree":30,"scores":{...},"reasons":{"overall":"reason in English"}}}';

if (priority === 'Comfortable fit' || priority === 'Moderate room') {
  prompt += '\n## Special Guidance for Comfortable Fit ##\n';
  prompt += 'If the candidate sizes do not fully meet the 15-20cm (6-8in) extra room guideline:\n';
  prompt += '1. Still recommend the LARGEST and BEST candidate size\n';
  prompt += '2. Add a note: "Note: This size is slightly snugger than the ideal comfort recommendation. Consider tailoring or our roomier styles."\n';
  prompt += '3. Provide scores and reasoning normally\n';
}
      return prompt;
    }
  };
  
  // Auto button generation
  document.addEventListener('DOMContentLoaded', function() {
    console.log('DOMContentLoaded - Initializing KFC Size Measurement');
    
    // Button display condition check
    var shouldShowButton = false;
    
    // Check if this product is in the target collections
    // Target collections: specific collections for KFC
    var targetCollectionIds = ['452755325155', '452755357923', '408945033443'];
    var collectionIdsScript = document.querySelector('script[id="ruffruff-order-limits-product-json"]');
    
    if (collectionIdsScript) {
      try {
        var productData = JSON.parse(collectionIdsScript.textContent);
        // Check if product is in ANY of the target collections
        if (productData.collectionIds && 
            productData.collectionIds.some(function(id) { 
              return targetCollectionIds.includes(id); 
            })) {
          console.log('[KFC] Collection check passed - KFC button will be shown');
          shouldShowButton = true;

          
          // Check if product has shirt-related tags
          if (productData.tags) {
            var hasShirtTag = productData.tags.some(function(tag) {
              return tag.toLowerCase().includes('shirt') || 
                     tag.toLowerCase().includes('button') ||
                     tag.toLowerCase().includes('classic') ||
                     tag.toLowerCase().includes('slim') ||
                     tag.toLowerCase().includes('tokyo') ||
                     tag.toLowerCase().includes('york');
            });
            
            if (hasShirtTag) {
              console.log('[KFC] Shirt tag found - KFC button will be shown');
              shouldShowButton = true;
            } else {
              console.log('[KFC] Not a shirt product - button will not be shown');
            }
          } else {
            console.log('[KFC] Product not in target collection - button will not be shown');
          }
        }
      } catch (e) {
        console.log('[KFC] Error parsing collection data:', e);
      }
    } else {
      console.log('[KFC] Collection data script not found');
    }
    
    if (!shouldShowButton) {
      console.log('[KFC] Display conditions not met - button will not be shown');
      return;
    }
    
    // Button HTML
    var buttonHTML = 
      '<style>' +
      '.kfc-fit-finder-btn { ' +
      'display: flex; ' +
      'align-items: center; ' +
      'justify-content: center; ' +
      'gap: 8px; ' +
      'padding: 12px 28px; ' +
      'background: linear-gradient(135deg, #3D2817 0%, #5C4033 100%); ' +
      'color: #f5f5f5; ' +
      'border: none; ' +
      'border-radius: 10px; ' +
      'font-size: 15px; ' +
      'font-weight: 600; ' +
      'font-family: "Noto Sans JP", sans-serif; ' +
      'cursor: pointer; ' +
      'transition: all 0.3s ease; ' +
      'box-shadow: none; ' +
      'letter-spacing: 0.5px; ' +
      'user-select: none; ' +
      'width: 100%; ' +
      'box-sizing: border-box; ' +
      'margin-bottom: 10px; ' +
      '}' +
      '.kfc-fit-finder-btn:hover { ' +
      'background: linear-gradient(135deg, #2d1f10 0%, #4a3028 100%); ' +
      '}' +
      '.kfc-fit-finder-btn:active { ' +
      'opacity: 0.9; ' +
      '}' +
      '.kfc-fit-finder-btn:disabled { ' +
      'opacity: 0.6; ' +
      'cursor: not-allowed; ' +
      '}' +
      '</style>' +
      '<div class="kfc-fit-finder-btn" id="kfc-btn-wrapper" style="cursor: pointer;">Find Your Perfect Fit</div>'; // Translated button text
    
    // Create wrapper div
    var wrapperDiv = document.createElement('div');
    wrapperDiv.style.cssText = 'text-align: center; margin: 20px 0;';
    wrapperDiv.innerHTML = buttonHTML;
    
    // Try to find Add to Cart button and insert before it
    var addToCartBtn = document.querySelector('[name="add"]') || 
                       document.querySelector('[id*="AddToCart"]') ||
                       document.querySelector('[id*="add-to-cart"]') ||
                       document.querySelector('button[class*="add-to-cart"]');
    
    if (addToCartBtn && addToCartBtn.parentNode) {
      addToCartBtn.parentNode.insertBefore(wrapperDiv, addToCartBtn);
      console.log('[KFC] Button inserted before Add to Cart button');
    } else {
      // Fallback: Try to find other placement locations
      var frmElement = document.getElementById('frm');
      if (frmElement) {
        frmElement.insertAdjacentElement('beforebegin', wrapperDiv);
        console.log('[KFC] Button inserted before frm');
      } else {
        // Final fallback: append to body
        document.body.appendChild(wrapperDiv);
        console.log('[KFC] Button appended to body');
      }
    }
    
    // Add click event listener to button
    var btnWrapper = document.getElementById('kfc-btn-wrapper');
    if (btnWrapper) {
      btnWrapper.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('KFC button clicked');
        window.KFCSizeMeasurement.open();
      });
    }
    
    console.log('KFC button generated successfully');
  });
})();

// ==========================================
// PART 2: KFC Integrated Size Logic
// ==========================================
window.KFCIntegratedSizeLogic = {
  
  realDataset: [
    { height: 191, weight: 75, size: '39-87' },
    { height: 170, weight: 52, size: '37-81' },
    { height: 176, weight: 58, size: '37-81' },
    { height: 174, weight: 70, size: '39-83' },
    { height: 178, weight: 69, size: '38-85' },
    { height: 173, weight: 65, size: '38-85' },
    { height: 176, weight: 70, size: '38-82' },
    { height: 176, weight: 58, size: '39-83' },
    { height: 174, weight: 64, size: '38-82' },
    { height: 168, weight: 53, size: '37-81' },
    { height: 165, weight: 58, size: '38-82' },
    { height: 180, weight: 65, size: '38-85' },
    { height: 176, weight: 78, size: '40-84' },
    { height: 182, weight: 70, size: '39-87' },
    { height: 174, weight: 56, size: '37-81' },
    { height: 179, weight: 70, size: '38-82' },
    { height: 180, weight: 87, size: '42-86' },
    { height: 170, weight: 55, size: '37-81' },
    { height: 173, weight: 65, size: '39-83' },
    { height: 165, weight: 73, size: '40-84' },
    { height: 182, weight: 74, size: '39-87' },
    { height: 173, weight: 69, size: '40-81' },
    { height: 176, weight: 72, size: '41-85' },
    { height: 168, weight: 65, size: '39-83' },
    { height: 170, weight: 65, size: '38-82' },
    { height: 171, weight: 73, size: '38-82' },
    { height: 172, weight: 57, size: '37-81' },
    { height: 172, weight: 70, size: '40-84' },
    { height: 175, weight: 82, size: '41-85' },
    { height: 171, weight: 63, size: '39-83' },
    { height: 166, weight: 54, size: '37-81' },
    { height: 167, weight: 53, size: '37-81' }
  ],
  
  sizeTable: [
    { size: '37-81', neck: 37.8, chest: 102, waist: 83, sleeve: 81.5 },
    { size: '38-82', neck: 38.8, chest: 106, waist: 87, sleeve: 82.5 },
    { size: '39-83', neck: 39.8, chest: 110, waist: 91, sleeve: 83.5 },
    { size: '38-85', neck: 38.8, chest: 106, waist: 87, sleeve: 85.5 },
    { size: '39-87', neck: 39.8, chest: 110, waist: 91, sleeve: 87.5 },
    { size: '40-81', neck: 40.8, chest: 114, waist: 95, sleeve: 81.5 },
    { size: '40-84', neck: 40.8, chest: 114, waist: 95, sleeve: 84.5 },
    { size: '41-85', neck: 41.8, chest: 118, waist: 99, sleeve: 85.5 },
    { size: '42-86', neck: 42.8, chest: 122, waist: 103, sleeve: 86.5 }
  ],
  
  findMostFrequentSizeFromRealData: function(height, weight) {
    var matches = this.realDataset.filter(function(record) {
      return Math.abs(record.height - height) <= 3 && Math.abs(record.weight - weight) <= 5;
    });
    if (matches.length === 0) return null;
    var sizeFrequency = {};
    matches.forEach(function(record) {
      sizeFrequency[record.size] = (sizeFrequency[record.size] || 0) + 1;
    });
    var mostFrequent = Object.keys(sizeFrequency).reduce(function(a, b) {
      return sizeFrequency[a] > sizeFrequency[b] ? a : b;
    });
    return { size: mostFrequent, frequency: sizeFrequency[mostFrequent], totalMatches: matches.length };
  },
  
  estimateBodyMeasurements: function(height, weight, priority) {
    var bmi = weight / Math.pow(height / 100, 2);
    var neckMin, neckMax;
    
    // ========================================
    // v5.1: Real data consistency improvement
    // (Prioritize degree, not lower limit)
    // ========================================
    // Step 1: BMI-based Neck range
if (bmi < 19.5) {
  neckMin = 37.0;
  neckMax = 39.0;  // 38.8も候補に
} else if (bmi < 22.0) {
  neckMin = 37.8;
  neckMax = 40.0;  // 38.8, 39.8が中心
} else if (bmi < 24.0) {
  neckMin = 39.0;
  neckMax = 41.0;  // 39.0, 39.8, 40.8
} else if (bmi < 26.0) {
  neckMin = 39.0;
  neckMax = 42.0;  // 39.8, 40.8, 41.8
} else if (bmi < 28.0) {
  neckMin = 40.0;
  neckMax = 43.0;  // 40.8, 41.8, 42.8
} else {
  neckMin = 41.0;
  neckMax = 100;
}

    
    // ========================================
    // Step 2: Apply Height-specific defaults (v5.1 improvement)
    // ※ "Height-specific defaults" function as "Priority degree" not lower limits
    // e.g. 180cm most frequent is 39-series, but 38-series is also a candidate
    // ========================================
    var heightAdjustment = 0;
    
    if (height >= 180) {
      // (39.8cm) is recommended, but 38-series is also a candidate
      // (Exclude 37-series, allow 38-series)
      neckMin = Math.max(neckMin, 38.0);
      neckMax = Math.min(neckMax + 1.0, 100);
      heightAdjustment = 1.0;
    } else if (height >= 175) {
      // Height 175-180cm → 38-series is default, but 37-series is also a candidate
      // (Allow 37-series)
      neckMin = Math.max(neckMin, 37.0);
      neckMax = Math.min(neckMax + 0.5, 100);
      heightAdjustment = 0.5;
    } else if (height >= 170) {
      // Height 170-175cm → Allow both 37-series and 38-series
      neckMin = Math.max(neckMin, 37.0);
      neckMax = Math.min(neckMax + 0.2, 100);
      heightAdjustment = 0.0;
    } else {
      // (Minimum 37cm)
      neckMin = Math.max(neckMin, 37.0);
    }
    
    // ========================================
    // Step 3: Fine-tuning based on priority
    // ========================================
    var priorityAdjustment = 0;
    if (priority === 'Comfortable fit' || priority === 'Easy movement') {
      // Prioritize room → Increase neck upper limit by +0.3~0.5
      neckMax = Math.min(neckMax + 0.5, 100);
      priorityAdjustment = 0.5;
    } else if (priority === 'Neck/sleeve length') {
      // Prioritize neck/sleeve length → Prioritize higher series
      neckMax = Math.min(neckMax + 0.3, 100);
      priorityAdjustment = 0.3;
    }
    
    var estimatedChest, estimatedWaist;
    if (bmi < 19.5) {
      estimatedChest = 90 + (height - 165) * 0.5;
      estimatedWaist = 75 + (height - 165) * 0.3;
    } else if (bmi < 22.0) {
      estimatedChest = 95 + (height - 165) * 0.6;
      estimatedWaist = 80 + (height - 165) * 0.4;
    } else if (bmi < 24.0) {
      estimatedChest = 100 + (height - 165) * 0.7;
      estimatedWaist = 88 + (height - 165) * 0.5;
    } else if (bmi < 25.5) {
      estimatedChest = 105 + (height - 165) * 0.75;
      estimatedWaist = 93 + (height - 165) * 0.55;
    } else {
      estimatedChest = 110 + (height - 165) * 0.8;
      estimatedWaist = 98 + (height - 165) * 0.6;
    }
    
    return {
      chest: Math.round(estimatedChest * 10) / 10,
      waist: Math.round(estimatedWaist * 10) / 10,
      neckMin: Math.round(neckMin * 10) / 10,
      neckMax: Math.round(neckMax * 10) / 10,
      neckCenter: Math.round((neckMin + neckMax) / 2 * 10) / 10,
      bmi: Math.round(bmi * 100) / 100,
      height: height,
      heightAdjustment: heightAdjustment,
      priorityAdjustment: priorityAdjustment,
      priority: priority
    };
  },
  
  calculateSizeCandidates: function(height, weight, bodyType, priority, armLength) {
    var candidates = [];
    var measurements = this.estimateBodyMeasurements(height, weight, priority);
    
    // ========================================
    // v5.2: Scoring optimization by armLength
    // ========================================
    console.log('[KFC v5.2] BMI: ' + measurements.bmi.toFixed(2) + ', armLength: ' + armLength + ', Neck range: ' + measurements.neckMin.toFixed(1) + '～' + measurements.neckMax.toFixed(1) + 'cm');
    
    // Filter sizes with neck within range
    var neckValidSizes = this.sizeTable.filter(function(sizeSpec) {
      return sizeSpec.neck >= measurements.neckMin && sizeSpec.neck <= measurements.neckMax;
    });
    
    console.log('[KFC v5.2] Filtered sizes (neck range): ' + neckValidSizes.map(function(s) { return s.size + '(' + s.neck + ')'; }).join(', '));
    
    if (neckValidSizes.length === 0) {
      console.log('[KFC v5.2] WARNING: No sizes in neck range.');
      return [];
    }
    
    // ========== Real data matching ==========
    var realDataResult = this.findMostFrequentSizeFromRealData(height, weight);
    if (realDataResult) {
      var realDataSizeObj = this.sizeTable.find(function(s) { return s.size === realDataResult.size; });
      if (realDataSizeObj && realDataSizeObj.neck >= measurements.neckMin && realDataSizeObj.neck <= measurements.neckMax) {
        candidates.push({
          size: realDataResult.size,
          source: 'realData',
          confidence: realDataResult.totalMatches,
          priority: 1,
          neckRating: 'MATCH'
        });
        console.log('[KFC v5.2] Real data match: ' + realDataResult.size);
      }
    }
    
    // ========== Scoring (v5.2: Dynamic weight adjustment by armLength)==========
    var self = this;
    var scoredSizes = neckValidSizes.map(function(sizeSpec) {
      var chestDiff = Math.abs(sizeSpec.chest - measurements.chest);
      var waistDiff = Math.abs(sizeSpec.waist - measurements.waist);
      var neckDiff = Math.abs(sizeSpec.neck - measurements.neckCenter);
      
      // ========== v5.2: Weight adjustment by armLength ==========
      var chestWeight = 2.0;
      var waistWeight = 1.5;
      var neckWeight = 0.5;
      
      if (armLength === 'Longer') {
        // Long arms → Prioritize long sleeve length (higher neck)
        // Prioritize high-neck sizes by minimizing neck difference
        neckWeight = 3.0;  // (Choose higher neck)
        waistWeight = 1.0; // Reduced waist importance
        console.log('[KFC v5.2] armLength=Longer with sleeve length priority scoring');
      } else if (armLength === 'Shorter') {
        // Short arms → Prioritize short sleeve length (lower neck)
        neckWeight = 3.0;  // (Choose lower neck)
        waistWeight = 1.0;
        // However, neckMin should be lowered, so low-neck sizes will naturally rank higher
      }
      
      var score = -(chestDiff * chestWeight + waistDiff * waistWeight + neckDiff * neckWeight);
      
      return {  
        size: sizeSpec.size, 
        score: score, 
        chest: sizeSpec.chest,
        waist: sizeSpec.waist,
        neck: sizeSpec.neck,
        neckDiff: neckDiff
      };
    }).sort(function(a, b) { return b.score - a.score; });
    
    console.log('[KFC v5.2] Top sizes by score: ' + scoredSizes.slice(0, 4).map(function(s) { return s.size + '(score:' + s.score.toFixed(1) + ')'; }).join(', '));
    
    // Add top 4 scores (remove duplicates)
    scoredSizes.slice(0, 4).forEach(function(item, index) {
      var alreadyExists = candidates.some(function(c) { return c.size === item.size; });
      if (!alreadyExists) {
        candidates.push({
          size: item.size,
          source: 'estimation',
          priority: index + 1,
          neckRating: 'IN_RANGE'
        });
      }
    });
    
    // Maximum 4
    var result = candidates.slice(0, 4);
    console.log('[KFC v5.2] Final candidates: ' + result.map(function(c) { return c.size; }).join(', '));
    return result;
  },
  
  debugSizeRecommendation: function(height, weight, bodyType, priority) {
    console.log('\n' + '='.repeat(70));
    console.log('KFC Size Recommendation - Debug Info v4 (Priority support version)'); // Translated version info
    console.log('='.repeat(70));
    console.log('Input: Height=' + height + 'cm, , Weight=' + weight + 'kg, Body Shape=' + bodyType);
    if (priority) console.log('Priority: ' + priority);
    
    var measurements = this.estimateBodyMeasurements(height, weight, priority);
    console.log('\n【Step 1】 BMI calculation and Estimated body size'); // Translated step title
    console.log('  BMI: ' + measurements.bmi.toFixed(2));
    console.log('  Estimated Neck (Range): ' + measurements.neckMin.toFixed(1) + '～' + measurements.neckMax.toFixed(1) + 'cm ★★★');
    if (measurements.heightAdjustment > 0) {
      console.log('  ⇒ Height adjustment: +' + measurements.heightAdjustment.toFixed(1) + 'cm');
    }
    if (measurements.priorityAdjustment > 0) {
      console.log('  ⇒ ' + priority + ' Priority: +' + measurements.priorityAdjustment.toFixed(1) + 'cm'); // Translated priority text
    }
    console.log('  Estimated chest: ' + measurements.chest.toFixed(1) + 'cm');
    console.log('  Estimated waist: ' + measurements.waist.toFixed(1) + 'cm');
    
    console.log('\n【Step 2】 List of sizes within Neck range'); // Translated step title
    var neckValidSizes = this.sizeTable.filter(function(s) { 
      return s.neck >= measurements.neckMin && s.neck <= measurements.neckMax; 
    });
    if (neckValidSizes.length > 0) {
      neckValidSizes.forEach(function(s) {
        console.log('  ✅ ' + s.size + ' (Neck: ' + s.neck + ', Chest: ' + s.chest + ', Waist: ' + s.waist + ')'); // Translated labels
      });
    } else {
      console.log('  ❌ No sizes in Neck range'); // Translated message
    }
    
    console.log('\n【Step 3】 Real data matching');
    var realDataResult = this.findMostFrequentSizeFromRealData(height, weight);
    if (realDataResult) {
      console.log('  Matches: ' + realDataResult.totalMatches + ' people'); // Translated '人'
      console.log('  Most Frequent: ' + realDataResult.size);
    } else {
      console.log('  No real data match');
    }
    
    console.log('\n【Step 4】 Final Candidates (' + (priority || 'Default') + ' Priority)');
    var candidates = this.calculateSizeCandidates(height, weight, bodyType, priority);
    candidates.forEach(function(c, i) {
      console.log('  ' + (i + 1) + '. ' + c.size + ' (Priority: ' + c.priority + ')');
    });
    
    console.log('\n' + '='.repeat(70) + '\n');
    return candidates;
  }
};

console.log('[KFCIntegratedSizeLogic] Loaded (included in kfc-size-measurement_v01.js)');

// buildPrompt Extension (v4)
if (window.KFCSizeMeasurement && window.KFCSizeMeasurement.buildPrompt) {
  var originalBuildPrompt = window.KFCSizeMeasurement.buildPrompt;
  
  window.KFCSizeMeasurement.buildPrompt = function(userGender, height, weight, age, armLength, fitPreference, bodyShape, priority, sizeTableData, bust) {
    var originalPrompt = originalBuildPrompt.call(this, userGender, height, weight, age, armLength, fitPreference, bodyShape, priority, sizeTableData, bust);
    
    if (window.KFCIntegratedSizeLogic) {
      // v5.2: Add armLength to scoring
      var candidates = window.KFCIntegratedSizeLogic.calculateSizeCandidates(height, weight, bodyShape, priority, armLength);
      if (candidates.length > 0) {
        var candidateSizes = candidates.map(function(c) { return c.size; }).join(', ');
        var priorityInstruction = '';
        var armLengthInstruction = '';
        
        // Add instruction based on armLength
        if (armLength === 'Longer') {
          armLengthInstruction = 'Since your arms are longer, prioritize sizes with longer sleeve length.';
        } else if (armLength === 'Shorter') {
          armLengthInstruction = 'Since your arms are shorter, prioritize sizes with shorter sleeve length.';
        }
        
        // Add instruction based on priority (Translated)
        if (priority === 'Clean silhouette') {
          priorityInstruction = 'The customer prioritizes a "Clean Silhouette," so select a size that fits snugly, but not restrictively.';
        } else if (priority === 'Comfortable fit' || priority === 'Moderate room') {
          priorityInstruction = 'The customer prioritizes comfort and room, so please select a larger, roomier size from the above candidates.';
        } else if (priority === 'Easy movement') {
          priorityInstruction = 'The customer prioritizes "Easy Movement," so select a slightly larger size with more room in the shoulder and chest.';
        } else if (priority === 'Neck/sleeve length') {
          priorityInstruction = 'The customer prioritizes "Neck/Sleeve Details," so prioritize accurate fit measurements for those areas.';
        }
        
        // Translated/Unified prompt addition
return originalPrompt + 
  '\n\n## AI Selection Assistance Info (v5.2) ##\n' + 
  'Please prioritize selecting from the following candidate sizes: ' + candidateSizes + '\n' +
  'These sizes have been pre-filtered based on the customer\'s measurements.\n' +
  '■User Priority: ' + (priority || 'None') + '\n' + 
  '■User Arm Length: ' + (armLength || 'Normal') + '\n' + 
  (armLengthInstruction ? '■Arm Length Instruction: ' + armLengthInstruction + '\n' : '') + 
  '■General Instruction: ' + priorityInstruction;
      }
    }
    return originalPrompt;
  };
  
  window.KFCSizeMeasurement.debugSize = function(height, weight, bodyType, priority) {
    if (window.KFCIntegratedSizeLogic) {
      return window.KFCIntegratedSizeLogic.debugSizeRecommendation(height, weight, bodyType, priority);
    }
  };
  
  console.log('[KFC Adapter] buildPrompt extended (v4 - Priority support version)'); // Translated
}